/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import HistoryIcon from "@mui/icons-material/History";
import { DATAPIPE_STATUS } from "../../app/Constants/Constants";
import { addCustomEvent } from "../../app/Utilities/utils";
import {
  SUPER_ADMIN_ROLE,
  CUSTOM_DATA_GROUP,
  CON_IMG_URL,
} from "../../constants/Constants";

//
//  HERE KEY IS GIVEN IN ACCORDANCE WITH FIELD KEY TO BE PASSED WHEN SORTING THE CORRESPONDING FIELD ─────
//

export const filterBoxData = /* istanbul ignore next */ (
  companies,
  currentRole,
  roles,
) => {
  const DPList = [
    {
      name: "Status",
      DPValue: DATAPIPE_STATUS.sort().map(
        /* istanbul ignore next */ (status) => {
          return {
            id: Math.random().toString(36).slice(2, 7),
            name: status.name,
            value: status.value,
            type: "status",
          };
        },
      ),
    },
  ];
  return {
    DPList,
  };
};
export const filterDefaultData = () => {
  return {
    id: Math.random().toString(36).slice(2, 7),
    name: "Active",
    type: "status",
  };
};
export const titles = [
  {
    key: "status",
    label: "Status",
  },
  {
    key: "title",
    label: "Name",
    sortable: true,
    sortKey: "title",
  },
  {
    key: "collectors",
    label: "Collectors",
  },
  {
    key: "connectors",
    label: "Connectors",
  },
];

export const getListViewObj = (datapipe, auth) => {
  const obj = {
    key: datapipe.id,
    status: {
      value: datapipe.disabled,
      view: "status",
    },
    title: {
      value: datapipe.title,
    },
    collectors: {
      value: datapipe.collectors.length || 0,
    },
    connectors: {
      value: datapipe.connectors.length || 0,
    },
    hideFromCustomer: {
      value: datapipe?.hideFromCustomer,
    },
  };
  /* istanbul ignore else */
  if (auth && auth.user && auth.user.roleName === SUPER_ADMIN_ROLE) {
    obj.company = {
      value: datapipe.companyName,
    };
  }
  return obj;
};
export const connectorDataPipeBO = /* istanbul ignore next */ (
  connector,
  player,
) => ({
  connectorId: connector.connectorId,
  dzConnectorId: connector.dzConnectorId,
  connectorName: connector.connectorName,
  icon: connector.icon,
  id: connector.id,
  connectorConfigName: connector.name,
  disabled: connector.disabled,
  dzInternal: connector.dzInternal,
  convertToDdv2: connector.convertToDdv2,
  iconUrl: CON_IMG_URL + connector.icon,
});
export const collectorDataPipeBO = /* istanbul ignore next */ (
  collector,
  player,
) => ({
  collectorId: collector.playerId,
  collectorName: player.name,
  configId: collector.id,
  configName: collector.name,
  disabled: collector.disabled,
  icon: collector.icon,
  platformIcon: collector.platformIcon,
  playHeadFrequency: collector.playHeadFrequency,
  collectorType: player.collectorType,
  eventList: player.eventList.map((event) => ({
    id: event.id,
    dictionaryVersionDatapointMappingId: event.id,
    name: event.name,
    label: event.label,
    deprecated: event.deprecated,
    supportedMediaTypes: event.supportedMediaTypes,
    required: event.required,
    selected: true,
  })),
  fluxDataList: player.fluxDataList.map((flux) => ({
    id: flux.id,
    dictionaryVersionDatapointMappingId: flux.id,
    name: flux.name,
    label: flux.label,
    deprecated: flux.deprecated,
    required: flux.required,
    selected: true,
  })),
  metaDataList: player.metaDataList.map((meta) => ({
    id: meta.id,
    dictionaryVersionDatapointMappingId: meta.id,
    name: meta.name,
    label: meta.label,
    deprecated: meta.deprecated,
    required: meta.required,
    selected: true,
  })),
});
export const collectorDataPipeFromInnerGridBO = /* istanbul ignore next */ (
  collector,
  playerData,
) => {
  const eventList = [];
  const fluxDataList = [];
  const metaDataList = [];
  playerData.forEach((data) => {
    if (!data.id) return;
    switch (data.label) {
      case "event":
        eventList.push({
          id: data.id,
          dictionaryVersionDatapointMappingId: data.id,
          name: data.name,
          label: data.label,
          deprecated: data.deprecated,
          required: data.required,
          selectedMediaTypes: data.selectedMediaTypes,
          supportedMediaTypes: data.supportedMediaTypes,
          selected: data.selected,
        });
        break;
      case "fluxdata":
        fluxDataList.push({
          id: data.id,
          dictionaryVersionDatapointMappingId: data.id,
          name: data.name,
          label: data.label,
          deprecated: data.deprecated,
          required: data.required,
          selected: data.selected,
        });
        break;
      case "metadata":
        metaDataList.push({
          id: data.id,
          dictionaryVersionDatapointMappingId: data.id,
          name: data.name,
          label: data.label,
          deprecated: data.deprecated,
          required: data.required,
          selected: data.selected,
        });
        break;
      default:
        break;
    }
  });

  return {
    collectorId: collector.collectorId,
    collectorName: collector.collectorName,
    configId: collector.configId,
    configName: collector.configName,
    disabled: collector.disabled,
    eventList,
    fluxDataList,
    icon: collector.icon,
    metaDataList,
    platformIcon: collector.platformIcon,
    playHeadFrequency: collector.playHeadFrequency,
    collectorType: collector.collectorType,
  };
};
export const collectorDataPipeFromInnerGridBO_V2 = (collector, playerData) => {
  const result = {
    collectorIcon: collector.collectorIcon,
    collectorId: collector.collectorId,
    collectorName: collector.collectorName,
    configId: collector.configId,
    configName: collector.configName,
    disabled: collector.disabled,
    general: { eventList: [], fluxDataList: [], metaDataList: [] },
    custom: [],
    vendor: [],
    pluginIcon: collector.pluginIcon,
    pluginId: collector.pluginId,
    pluginName: collector.pluginName,
    plugin: collector.plugin,
    dataPointList: [],
  };
  if (collector.plugin)
    result.mediaPlayer = {
      eventList: [],
      fluxDataList: [],
      metaDataList: [],
    };
  playerData.forEach((data) => {
    let {
      mainGroup,
      group,
      datapointsList,
      originalId,
      subGroup,
      dataPointId,
      name,
      deprecated,
      required,
      selectedMediaTypes,
      supportedMediaTypes,
      selected,
      label,
    } = data;
    mainGroup =
      mainGroup === "General"
        ? "general"
        : mainGroup === "Custom"
        ? "custom"
        : mainGroup === "Vendor"
        ? "vendor"
        : "mediaPlayer";
    if (group === "Events") {
      result[mainGroup].eventList.push({
        dataPointId,
        label,
        name,
        deprecated,
        required,
        selectedMediaTypes,
        supportedMediaTypes,
        selected,
        group,
        datapointsList,
        originalId,
      });
    } else if (group === "Fluxdata") {
      result[mainGroup].fluxDataList.push({
        dataPointId,
        label,
        name,
        deprecated,
        required,
        selected,
        group,
      });
    } else if (group === "Metadata") {
      result[mainGroup].metaDataList?.push({
        dataPointId,
        label,
        name,
        deprecated,
        required,
        selected,
        group: subGroup,
      });
    } else if (group === "Custom") {
      result?.custom?.push({
        dataPointId,
        label,
        name,
        deprecated,
        required,
        selected,
        group,
      });
    } else if (group === "Vendor") {
      result?.vendor?.push({
        dataPointId,
        label,
        name,
        deprecated,
        required,
        selected,
        group,
      });
    }
  });
  return result;
};

export const dataPipeBO = (datapipe) => {
  let obj = {};
  if (datapipe.id !== undefined) {
    obj.id = datapipe.id;
  }
  obj = {
    ...obj,
    name: datapipe.name,
    companyId: datapipe.companyId,
    collectorConfigs: datapipe.collectorConfigs.map((collectorConfig) => ({
      id: collectorConfig.configId,
      eventsList: collectorConfig.eventList
        .filter((eventList) => eventList.selected)
        .map((events) => ({
          id: events.dictionaryVersionDatapointMappingId,
          selectedMediaTypesArray: events.selectedMediaTypes,
        })),
      fluxDataList: collectorConfig.fluxDataList
        .filter((fluxDataList) => fluxDataList.selected)
        .map((flux) => ({
          id: flux.dictionaryVersionDatapointMappingId,
        })),
      metaDataList: collectorConfig.metaDataList
        .filter((metaDataList) => metaDataList.selected)
        .map((metadata) => ({
          id: metadata.dictionaryVersionDatapointMappingId,
        })),
    })),
    connectorConfigs: datapipe.connectorConfigs.map((connectorConfig) => ({
      id: connectorConfig.id,
    })),
  };
  return obj;
};
export const dataPipeBO_V2 = (datapipe) => {
  let obj = {};
  if (datapipe.id !== undefined) {
    obj.id = datapipe.id;
  }

  obj = {
    ...obj,
    name: datapipe.name,
    companyId: datapipe.companyId,
    collectorConfigs: datapipe.collectorConfigs.map((collectorConfig) => {
      const collectorData = {
        configId: collectorConfig.configId,
      };
      const general = {
        events: rearrangeGroupedDataV3(
          collectorConfig?.general?.eventList || [],
        ),
        fluxdata:
          collectorConfig?.general?.fluxDataList
            ?.filter((flux) => flux.selected || flux.required)
            .map((fluxData) => ({
              id: fluxData.dataPointId,
            })) || [],
        metadata:
          collectorConfig?.general?.metaDataList
            ?.filter((meta) => meta.selected || meta.required)
            .map((metaData) => ({
              id: metaData.dataPointId,
            })) || [],
      };
      collectorData.general = general;
      if (collectorConfig.plugin) {
        const mediaPlayer = {
          events: rearrangeGroupedDataV3(
            collectorConfig?.mediaPlayer?.eventList || [],
          ),
          fluxdata:
            collectorConfig?.mediaPlayer?.fluxDataList
              ?.filter((flux) => flux.selected || flux.required)
              .map((fluxData) => ({
                id: fluxData.dataPointId,
              })) || [],
          metadata:
            collectorConfig?.mediaPlayer?.metaDataList
              ?.filter((meta) => meta.selected || meta.required)
              .map((metadata) => ({
                id: metadata.dataPointId,
              })) || [],
        };
        if (
          mediaPlayer.events.length > 0 ||
          mediaPlayer.fluxdata.length > 0 ||
          mediaPlayer.metadata.length > 0
        ) {
          collectorData.mediaPlayer = mediaPlayer;
        }
      }
      const custom =
        collectorConfig?.custom
          ?.filter((cust) => cust.selected || cust.required)
          .map((customData) => ({
            id: customData.dataPointId,
          })) || [];
      if (custom.length > 0) {
        collectorData.custom = custom;
      }

      const vendor =
        collectorConfig?.vendor
          ?.filter((vendor) => vendor.selected || vendor.required)
          .map((venderData) => ({
            id: venderData.dataPointId,
          })) || [];
      if (vendor.length > 0) {
        collectorData.vendor = vendor;
      }
      return collectorData;
    }),
    connectorConfigs: datapipe.connectorConfigs.map((connectorConfig) => ({
      id: connectorConfig.id,
    })),
  };
  return obj;
};

const rearrangeGroupedDataV3 = (groupedData) => {
  const transformedData = [];
  groupedData.forEach((data) => {
    if (data?.datapointsList) {
      data?.datapointsList?.forEach((datapoint) => {
        transformedData.push({
          id: datapoint?.id,
          required: data.required,
          selected: datapoint.selected,
          selectedMediaType: datapoint.mediaTypeName,
        });
      });
    } else {
      transformedData.push({
        id: data?.dataPointId,
        required: data.required,
        selected: data.selected,
        selectedMediaType: data.mediaType,
      });
    }
  });
  const filteredData = transformedData
    .filter((item) => item.required === true || item.selected === true)
    .map(({ required, selected, ...rest }) => rest);
  return filteredData;
};

export const dataPipeCreate_BO_V2 = (datapipe) => {
  let obj = {};
  obj = {
    ...obj,
    name: datapipe.name,
    companyId: datapipe.companyId,
    collectorConfigs: datapipe.collectorConfigs.map((collectorConfig) => {
      const collectorData = {
        configId: collectorConfig.configId,
      };
      const general = {
        eventsList: rearrangeGroupedDataV3(
          collectorConfig?.general?.eventList || [],
        ),
        fluxDataList:
          collectorConfig?.general?.fluxDataList
            ?.filter((flux) => flux.selected || flux.required)
            .map((fluxData) => ({
              id: fluxData.dataPointId,
            })) || [],
        metaDataList:
          collectorConfig?.general?.metaDataList
            ?.filter((meta) => meta.selected || meta.required)
            .map((metaData) => ({
              id: metaData.dataPointId,
            })) || [],
      };
      // Only include `general` if it has data
      if (
        general.eventsList.length > 0 ||
        general.fluxDataList.length > 0 ||
        general.metaDataList.length > 0
      ) {
        collectorData.general = general;
      }
      if (collectorConfig.plugin) {
        const mediaPlayer = {
          eventsList: rearrangeGroupedDataV3(
            collectorConfig?.mediaPlayer?.eventList || [],
          ),
          fluxDataList:
            collectorConfig?.mediaPlayer?.fluxDataList
              ?.filter((flux) => flux.selected || flux.required)
              .map((fluxData) => ({
                id: fluxData.dataPointId,
              })) || [],
          metaDataList:
            collectorConfig?.mediaPlayer?.metaDataList
              ?.filter((meta) => meta.selected || meta.required)
              .map((metadata) => ({
                id: metadata.dataPointId,
              })) || [],
        };
        if (
          mediaPlayer.eventsList.length > 0 ||
          mediaPlayer.fluxDataList.length > 0 ||
          mediaPlayer.metaDataList.length > 0
        ) {
          collectorData.mediaPlayer = mediaPlayer;
        }
      }
      const custom =
        collectorConfig?.custom
          ?.filter((cust) => cust.selected || cust.required)
          .map((customData) => ({
            id: customData.dataPointId,
          })) || [];
      if (custom.length > 0) {
        collectorData.custom = custom;
      }

      const vendor =
        collectorConfig?.vendor
          ?.filter((vendor) => vendor.selected || vendor.required)
          .map((venderData) => ({
            id: venderData.dataPointId,
          })) || [];
      if (vendor.length > 0) {
        collectorData.vendor = vendor;
      }
      return collectorData;
    }),
    connectorConfigs: datapipe.connectorConfigs.map((connectorConfig) => ({
      id: connectorConfig.id,
    })),
  };
  return obj;
};
export const datapipeCustomEventBO = (datapipe) => {
  const datapipeResponse = datapipe;
  if (datapipeResponse?.collectorConfigs.length > 0) {
    datapipeResponse?.collectorConfigs?.forEach((collectorConfig) => {
      collectorConfig = addCustomEvent(collectorConfig);
    });
  }
  return datapipeResponse;
};
export const checkWarningBO = /* istanbul ignore next */ (datapipe) => {
  let obj = {};
  if (datapipe?.id !== undefined) {
    obj.id = datapipe.id;
  }
  obj = {
    ...obj,
    companyId: datapipe?.companyId,
    companyName: datapipe?.companyName,
    disabled: datapipe?.disabled,
    name: datapipe?.name,
    collectorConfigs: datapipe?.collectorConfigs?.map((collectorConfig) => ({
      id: collectorConfig.configId,
      eventsList: collectorConfig.eventList.map((event) => ({
        id: event.dictionaryVersionDatapointMappingId,
        selectedMediaTypesArray: event.selectedMediaTypes,
        selected: event.selected,
      })),
      fluxDataList: collectorConfig.fluxDataList.map((flux) => ({
        id: flux.dictionaryVersionDatapointMappingId,
        selected: flux.selected,
      })),
      metaDataList: collectorConfig.metaDataList.map((meta) => ({
        id: meta.dictionaryVersionDatapointMappingId,
        selected: meta.selected,
      })),
    })),
    connectorConfigs: datapipe?.connectorConfigs?.map((connectorConfig) => ({
      id: connectorConfig.id,
    })),
  };
  return obj;
};
export const checkWarningBO_V2 = /* istanbul ignore next */ (datapipe) => {
  let obj = {};
  if (datapipe?.id !== undefined) {
    obj.id = datapipe.id;
  }
  obj = {
    ...obj,
    companyId: datapipe?.companyId,
    companyName: datapipe?.companyName,
    disabled: datapipe?.disabled,
    name: datapipe?.name,
    collectorConfigs: datapipe?.collectorConfigs?.map((collectorConfig) => {
      return collectorConfig.listNode;
    }),
    connectorConfigs: datapipe?.connectorConfigs?.map((connectorConfig) => ({
      id: connectorConfig.id,
    })),
  };
  return obj;
};

export const extractLists = (
  obj,
  parentData = {},
  section = "general",
  isTopLevel = true,
  auth,
) => {
  if (!obj) return [];

  let result = [];
  const collectorTypeMap = new Map();

  if (isTopLevel) {
    const collectorConfigs = obj?.collectorConfigs || [];
    const allConfigNames = new Set(
      collectorConfigs.map(({ configName }) => configName),
    );

    collectorConfigs.forEach(({ configId, collectorType }) => {
      if (configId && collectorType) {
        collectorTypeMap.set(configId, collectorType);
      }
    });

    result = collectorConfigs.flatMap((config) =>
      extractLists(config, {}, section, false, auth),
    );

    return groupByLabel(result, allConfigNames, collectorConfigs, auth);
  }

  const resolvedConfigId = obj.configId ?? parentData.configId;
  const newParentData = {
    ...parentData,
    ...obj,
    configId: resolvedConfigId,
    section: section?.toLowerCase(),
    collectorType:
      obj.collectorType ??
      parentData.collectorType ??
      collectorTypeMap.get(resolvedConfigId),
  };

  Object.entries(obj).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      result.push(
        ...value.map((item) => ({
          ...newParentData,
          ...item,
          collectorType: item.collectorType ?? newParentData.collectorType,
          type: getTypeFromKey(key),
        })),
      );
    } else if (typeof value === "object" && value !== null) {
      const sectionMap = {
        mediaPlayer: "mediaPlayer",
        custom: "Custom",
        vendor: "Vendor",
        alias: "alias",
      };
      result.push(
        ...extractLists(
          value,
          newParentData,
          sectionMap[key] || section,
          false,
          auth,
        ),
      );
    }
  });
  if (
    process.env.REACT_APP_NEW_DATAPOINT_TABLE_V2 === "true" &&
    auth?.user?.roleName === SUPER_ADMIN_ROLE
  ) {
    result.filter(
      (item) =>
        item?.deprecated === true &&
        item?.selected === false &&
        item?.required === false,
    );
  }
  // if (
  //   process.env.REACT_APP_NEW_DATAPOINT_TABLE_V2 === "true" &&
  //   auth?.user?.roleName !== SUPER_ADMIN_ROLE
  // ) {
  //   return (result = result.filter((item) => item?.omitFromUi !== true));
  // }
  return result;
};

function getTypeFromKey(key) {
  if (key === "eventList" || key === "events") return "event";
  if (key === "fluxDataList") return "fluxdata";
  if (key === "metaDataList" || key === "metadata") return "metadata";
  if (key === "custom") return "Custom";
  if (key === "vendor") return "Vendor";
  return "unknown";
}

function groupByLabel(data, allConfigNames, collectorConfigs, auth) {
  if (!data?.length) return null;
  const groupedData = {};
  const metadataGroups = {
    allMetadata: [],
    cdnMetadata: [],
    applicationMetadata: [],
  };

  const seenMetadataIds = new Set();

  data.forEach((item) => {
    const isCDN = item?.collectorType?.toLowerCase() === "cdn";
    const subkey = item?.type === "metadata" && isCDN ? "cdnMetadata" : "";
    let key;
    if (item?.type === "Custom") {
      key = `${item?.name}_${item?.type}${subkey}` ?? "unknown";
    } else {
      key = `${item?.label}_${item?.type}${subkey}` ?? "unknown";
    }
    if (!groupedData[key]) {
      groupedData[key] = {
        ...removeUnwantedFields(item),
        exception_list: new Set(),
        includes_list: new Set(),
        type: item.type,
        selected: item?.selected,
        collectorType: item?.collectorType,
        supportedMediaTypes: new Set(),
        selectedMediaTypes: new Set(),
        group:
          item?.section === "alias" && item?.type === "metadata"
            ? "Custom metadata"
            : item?.group,
      };

      if (item.type === "event") {
        groupedData[key].additional_info = [];
      }
    }

    const isCustomOrVendor = item.type === "Custom" || item.type === "Vendor";

    if (isCustomOrVendor && item.label?.toLowerCase().includes("event")) {
      groupedData[key].type = "event";
      groupedData[key].originalType = item.type;
    } else if (
      isCustomOrVendor &&
      item.label?.toLowerCase().includes("metadata")
    ) {
      groupedData[key].group = item?.type;
      groupedData[key].originalType = item.type;
      groupedData[key].type = "metadata";

      const dpKey = item.dataPointId;
      if (!seenMetadataIds.has(dpKey)) {
        seenMetadataIds.add(dpKey);
        const metadataItem = {
          ...item,
          originalType: item.type,
          includes_list: groupedData[key].includes_list,
          exception_list: groupedData[key].exception_list,
        };
        if (isCDN) {
          metadataGroups.cdnMetadata.push(metadataItem);
        } else {
          metadataGroups.applicationMetadata.push(metadataItem);
        }
      }
    } else if (item.type === "metadata") {
      const dpKey = item.dataPointId;
      if (!seenMetadataIds.has(dpKey)) {
        seenMetadataIds.add(dpKey);
        const metadataItem = {
          ...item,
          includes_list: groupedData[key].includes_list,
          exception_list: groupedData[key].exception_list,
        };
        if (isCDN) {
          metadataGroups.cdnMetadata.push(metadataItem);
        } else {
          metadataGroups.applicationMetadata.push(metadataItem);
        }
      }
    } else if (item.type === "fluxdata") {
      groupedData[key].type = "fluxdata";
    }

    if (groupedData[key].type === "event") {
      const existing = groupedData[key]?.additional_info?.find(
        (info) =>
          info.dataPointId === item.dataPointId &&
          info.mediaType === item.mediaType,
      );
      if (existing) {
        if (!existing.configIds.includes(item.configId)) {
          existing.configIds.push(item.configId);
          if (item?.selected === true) {
            existing.selected = true;
            groupedData[key]?.selectedMediaTypes.add(item?.mediaType);
          }
        }
      } else {
        groupedData[key]?.additional_info?.push({
          dataPointId: item.dataPointId,
          name: item.name,
          label: item.label,
          required: item.required,
          deprecated: item.deprecated,
          selected: item.selected,
          mediaType: item.mediaType,
          configIds: [item?.configId],
        });
      }

      if (item.mediaType && item.mediaType !== "not_appl") {
        groupedData[key].supportedMediaTypes.add(item.mediaType);
        if (groupedData[key].selected === true) {
          groupedData[key].selectedMediaTypes.add(item.mediaType);
        }
      }
    }

    const relevantFields = extractRelevantFields(item);
    if (relevantFields.configId) {
      groupedData[key].includes_list.add(relevantFields);
    }
  });

  if (metadataGroups.cdnMetadata.length === 0) {
  }

  function processMetadataGroup(metadataGroup, type, collectorConfigs) {
    if (!Array.isArray(metadataGroup)) return [];

    return metadataGroup.map((item) => {
      const includesArray = Array.from(item.includes_list || []);
      item.includes_list = Array.from(
        new Map(includesArray.map((i) => [i.configId, i])).values(),
      );

      const currentConfigIds = new Set(
        item.includes_list.map((i) => i.configId),
      );
      item.exception_list = Array.isArray(collectorConfigs)
        ? collectorConfigs
            .filter(
              (cfg) => cfg?.configId && !currentConfigIds.has(cfg.configId),
            )
            .filter((cfg) => {
              const isCDN = cfg.collectorType?.toLowerCase() === "cdn";
              return type === "cdn" ? isCDN : !isCDN;
            })
            .map((cfg) => extractRelevantFields(cfg))
        : [];
      if (item?.includes_list?.some((e) => e?.selected || e?.required)) {
        item.selected = true;
      }
      if (item?.type === "Custom" && item?.originalType === "Custom") {
        item = filterCollectorListsByType(item, type);
      }
      return item;
    });
  }

  Object.keys(groupedData).forEach((key) => {
    const item = groupedData[key];

    groupedData[key].includes_list = Array.from(
      new Map(
        [...groupedData[key].includes_list].map((obj) => [obj.configId, obj]),
      ).values(),
    );

    const currentConfigIds = new Set(
      groupedData[key].includes_list.map((item) => item.configId),
    );

    groupedData[key].exception_list = Array.from(
      new Map(
        [...collectorConfigs]
          .filter(
            (config) =>
              config?.configId && !currentConfigIds.has(config.configId),
          )
          .map((config) => [config.configId, extractRelevantFields(config)]),
      ).values(),
    );

    if (groupedData[key].supportedMediaTypes.size > 0) {
      groupedData[key].supportedMediaTypes = Array.from(
        groupedData[key].supportedMediaTypes,
      );
      groupedData[key].selectedMediaTypes = Array.from(
        groupedData[key].selectedMediaTypes,
      );
    } else {
      delete groupedData[key].supportedMediaTypes;
      delete groupedData[key].selectedMediaTypes;
    }

    groupedData[key].selected = groupedData[key].includes_list.some(
      (item) => item.selected === true,
    );
  });

  metadataGroups.applicationMetadata = processMetadataGroup(
    metadataGroups.applicationMetadata,
    "application",
    collectorConfigs,
  );

  metadataGroups.cdnMetadata = processMetadataGroup(
    metadataGroups.cdnMetadata,
    "cdn",
    collectorConfigs,
  );

  const categorizedData = {
    event: [],
    metadata: {
      allMetadata: metadataGroups.allMetadata?.sort((a, b) =>
        a.name.localeCompare(b.name),
      ),
      cdnMetadata: metadataGroups.cdnMetadata?.sort((a, b) =>
        a.name.localeCompare(b.name),
      ),
      applicationMetadata: metadataGroups.applicationMetadata?.sort((a, b) =>
        a.name.localeCompare(b.name),
      ),
    },
    fluxdata: [],
    alias: {
      event: [],
      metaData: {
        applicationMetadata: [],
        cdnMetadata: [],
      },
    },
  };

  Object.values(groupedData).forEach((item) => {
    if (!item || typeof item !== "object") return;

    if (item.type === "event") {
      if (item?.section !== "alias") {
        categorizedData.event.push(item);
        categorizedData.event?.sort((a, b) => a.label.localeCompare(b.label));
      } else if (item?.section === "alias") {
        if (auth?.user?.roleName === SUPER_ADMIN_ROLE) {
          categorizedData.alias.event.push(item);
          categorizedData.alias.event?.sort((a, b) =>
            a.label.localeCompare(b.label),
          );
        }
      }
    } else if (item.type === "fluxdata") {
      categorizedData.fluxdata.push(item);
      categorizedData.fluxdata?.sort((a, b) => a.label.localeCompare(b.label));
    }
  });
  const upadtedcategorizedData = updateAliasMetadataGroup(
    categorizedData,
    auth,
  );
  return upadtedcategorizedData;
}

function extractRelevantFields(obj) {
  return {
    collectorIcon: obj.collectorIcon ?? null,
    collectorId: obj.collectorId ?? null,
    collectorName: obj.collectorName ?? null,
    configId: obj.configId ?? null,
    configName: obj.configName ?? null,
    selected: obj.selected || obj?.required,
    mediaType: obj.mediaType ?? "not_appl",
    dataPointId: obj.dataPointId ?? null,
    pluginIcon: obj.pluginIcon,
    pluginId: obj.pluginId,
    pluginName: obj.pluginName,
    collectorType: obj.collectorType,
    adFrameworkName: obj.adFrameworkName,
    dictionaryName: obj?.dictionaryName,
    labelForSync: obj?.label,
  };
}

function removeUnwantedFields(obj) {
  const { companyId, companyName, disabled, hideFromCustomer, ...filteredObj } =
    obj;
  return filteredObj;
}

function updateAliasMetadataGroup(categorizedData, auth) {
  let { applicationMetadata = [], cdnMetadata = [] } = categorizedData.metadata;

  applicationMetadata.forEach((item) => {
    if (item.type === "metadata" && item.section === "alias") {
      item.group = "Custom Metadata";
    }
  });

  cdnMetadata.forEach((item) => {
    if (item.type === "metadata" && item.section === "alias") {
      item.group = "Custom Metadata";
    }
  });

  const isCustomDataDisabled = auth?.user?.roleName !== SUPER_ADMIN_ROLE;
  if (isCustomDataDisabled) {
    applicationMetadata = applicationMetadata.filter(
      (item) => item.section?.toLowerCase() !== "alias",
    );
    cdnMetadata = cdnMetadata.filter(
      (item) => item.section?.toLowerCase() !== "alias",
    );
  }

  if (auth?.user?.roleName === SUPER_ADMIN_ROLE) {
    applicationMetadata.forEach((item) => {
      if (item.type === "Custom") {
        item.section = "alias";
        item.label = "All Unmapped Keys";
        item.group = "Custom Metadata";
      }
    });

    cdnMetadata.forEach((item) => {
      if (item.type === "Custom") {
        item.section = "alias";
        item.label = "All Unmapped Keys";
        item.group = "Custom Metadata";
      }
    });
  }

  if (auth?.user?.roleName === SUPER_ADMIN_ROLE) {
    // Update label for custom event items
    categorizedData.event = (categorizedData.event || []).map((item) => {
      if (item.type === "event" && item.originalType === "Custom") {
        return {
          ...item,
          label: "All Unmapped Keys",
        };
      }
      return item;
    });
  }

  categorizedData.metadata.applicationMetadata = applicationMetadata;
  categorizedData.metadata.cdnMetadata = cdnMetadata;
  return categorizedData;
}

function moveAliasMetadataItems(categorizedData) {
  const { applicationMetadata = [], cdnMetadata = [] } =
    categorizedData.metadata;

  const aliasApplication = applicationMetadata.filter(
    (item) => item.section === "alias",
  );
  const remainingApplication = applicationMetadata.filter(
    (item) => item.section !== "alias",
  );

  const aliasCdn = cdnMetadata.filter((item) => item.section === "alias");
  const remainingCdn = cdnMetadata.filter((item) => item.section !== "alias");

  categorizedData.metadata.applicationMetadata = remainingApplication;
  categorizedData.metadata.cdnMetadata = remainingCdn;
  categorizedData.alias.metaData.applicationMetadata.push(...aliasApplication);
  categorizedData.alias.metaData.cdnMetadata.push(...aliasCdn);

  return categorizedData;
}

function filterMetadataBySection(metadataArray, section, configId, event) {
  if (!Array.isArray(metadataArray)) return [];

  const isValidUUID =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  return metadataArray
    .filter(
      (item) =>
        item.section === section &&
        (!item.originalType ||
          (item.originalType !== "Custom" && item.originalType !== "Vendor")),
    )
    .flatMap((item) => {
      if (Array.isArray(item.additional_info) && item.type === "event") {
        return item.additional_info
          .filter((info) => {
            const isIncluded = info.configIds?.includes(configId);
            const isException = item.exception_list?.some(
              (ex) =>
                ex.configId === configId && ex.dataPointId === info.dataPointId,
            );
            return isIncluded && !isException;
          })
          .map((info) => {
            let dataPointId = info?.dataPointId;
            if (!dataPointId || !isValidUUID.test(dataPointId)) {
              dataPointId = item?.additional_info?.[0]?.dataPointId;
              if (!dataPointId || !isValidUUID.test(dataPointId)) {
                dataPointId =
                  item?.additional_info?.[1]?.dataPointId ||
                  item?.datapointsList?.[0]?.id;
              }
            }

            if (!dataPointId || !isValidUUID.test(dataPointId)) return null;

            const existsInCurrent = Array.isArray(event)
              ? event.some((e) =>
                  isValidUUID.test(e?.dataPointId) === true
                    ? e?.dataPointId === dataPointId
                    : e?.datapointsList?.[0]?.id === dataPointId,
                )
              : false;

            if (!existsInCurrent) return null;

            // Find matching include entry
            const matchedInclude = item.includes_list?.find(
              (inc) =>
                inc.configId === configId && inc.dataPointId === dataPointId,
            );

            return {
              ...item,
              dataPointId,
              name: info.name,
              label: info.label,
              required: info.required,
              selected: matchedInclude?.selected ?? info.selected ?? false,
              selectedMediaTypes: item?.selectedMediaTypes,
              mediaType: info.mediaType,
              dataPointList: info?.dataPointList,
            };
          })
          .filter(Boolean); // Remove nulls
      }

      // Handle non-event metadata
      const isIncluded = item.includes_list?.some(
        (include) =>
          include.configId === configId &&
          include.dataPointId === item.dataPointId,
      );
      const isException = item.exception_list?.some(
        (ex) => ex.configId === configId && ex.dataPointId === item.dataPointId,
      );

      if (isIncluded && !isException) {
        const matchingInclude = item.includes_list.find(
          (include) =>
            include.configId === configId &&
            include.dataPointId === item.dataPointId,
        );
        return [
          {
            ...item,
            selected: matchingInclude?.selected ?? false,
          },
        ];
      }

      return [];
    })
    .map((item) => {
      const { includes_list, exception_list, ...rest } = item;
      return rest;
    });
}

function extractCustomAndVendorItems(
  categorizedData,
  type,
  configId,
  collectorItems = [],
) {
  const collectorIds = new Set(
    collectorItems.map((ci) => ci?.dataPointId).filter(Boolean),
  );

  const seenIds = new Set();

  const allItems = [
    ...(categorizedData?.metadata?.applicationMetadata || []),
    ...(categorizedData?.metadata?.cdnMetadata || []),
    ...(categorizedData?.event || []),
    ...(categorizedData?.fluxdata || []),
  ];

  for (const item of allItems) {
    const id = item?.dataPointId;
    const isCustom = type === "custom" && item.originalType === "Custom";
    const isVendor = type === "vendor" && item.originalType === "Vendor";
    if (!isCustom && !isVendor) continue;

    const isIncluded = item?.includes_list?.some(
      (inc) =>
        inc?.configId === configId &&
        (inc?.selected === true || inc?.required === true),
    );

    const isException = item?.exception_list?.some(
      (exc) => exc?.configId === configId,
    );

    if (id && isIncluded && !isException && collectorIds.has(id)) {
      seenIds.add(id);
    }
  }

  return Array.from(seenIds).map((id) => ({ id }));
}

function expandItemsByDatapointsList(items) {
  return items.flatMap((item) => {
    if (
      Array.isArray(item?.datapointsList) &&
      item?.datapointsList?.length > 1
    ) {
      return item.datapointsList.map((dp) => ({
        ...item,
        dataPointId: dp?.id,
        mediaType: dp?.mediaTypeName,
        selected: dp?.selected,
        datapointsList: [dp],
      }));
    }
    return [item];
  });
}

export function revertToOriginalStructure(
  currentCollectorConfigs,
  categorizedData,
) {
  if (!categorizedData || !Array.isArray(currentCollectorConfigs)) return null;
  return {
    collectorConfigs: currentCollectorConfigs.map((collector) => {
      const { configId } = collector;
      return {
        ...collector,
        general: {
          ...collector.general,
          eventList: filterMetadataBySection(
            categorizedData.event,
            "general",
            configId,
            collector?.general?.eventList,
          ),
          fluxDataList: filterMetadataBySection(
            categorizedData.fluxdata,
            "general",
            configId,
          ),
          metaDataList: filterMetadataBySection(
            [
              ...(categorizedData?.metadata?.applicationMetadata || []),
              ...(categorizedData?.metadata?.cdnMetadata || []),
            ],
            "general",
            configId,
          ),
        },
        mediaPlayer: {
          eventList: filterMetadataBySection(
            categorizedData?.event,
            "mediaplayer",
            configId,
            collector?.mediaPlayer?.eventList,
          ),
          fluxDataList: filterMetadataBySection(
            categorizedData?.fluxdata,
            "mediaplayer",
            configId,
          ),
          metaDataList: filterMetadataBySection(
            [
              ...(categorizedData?.metadata?.applicationMetadata || []),
              ...(categorizedData?.metadata?.cdnMetadata || []),
            ],
            "mediaplayer",
            configId,
          ),
        },
        custom: extractCustomAndVendorItems(
          categorizedData,
          "custom",
          configId,
          collector?.custom,
        ),
        alias: {
          event: extractAliasItem(
            categorizedData?.alias?.event,
            configId,
            "event",
          ),
          metadata: extractAliasItem(
            collector?.collectorType === "CDN"
              ? categorizedData?.metadata?.cdnMetadata
              : categorizedData?.metadata?.applicationMetadata,
            configId,
            "metadata",
          ),
        },
        vendor: extractCustomAndVendorItems(
          categorizedData,
          "vendor",
          configId,
          collector?.vendor,
        ),
      };
    }),
  };
}

function extractAliasItem(metadataArray, configId, type) {
  if (!Array.isArray(metadataArray)) return [];

  return metadataArray
    .filter((item) => item?.section === "alias" && item?.type !== "Custom")
    .flatMap((item) => {
      const isTopLevelExcluded = item.exception_list?.some(
        (exc) =>
          exc.configId === configId &&
          (exc.dataPointId === null || exc.dataPointId === item.dataPointId),
      );

      if (isTopLevelExcluded) return [];

      if (type === "event" && Array.isArray(item.additional_info)) {
        return item.additional_info
          .filter((info) => info.configIds?.includes(configId))
          .map((info) => {
            const isInfoExcluded = item.exception_list?.some(
              (exc) =>
                exc.configId === configId &&
                (exc.dataPointId === null ||
                  exc.dataPointId === info.dataPointId),
            );

            if (isInfoExcluded) return null;

            const matchedInclude = item.includes_list?.find(
              (inc) =>
                inc.configId === configId &&
                inc.dataPointId === info.dataPointId,
            );

            return {
              ...item,
              dataPointId: info.dataPointId,
              name: info.name,
              label: info.label,
              required: info.required,
              selected: matchedInclude?.selected ?? info.selected ?? false,
            };
          })
          .filter(Boolean);
      }

      const matchedInclude = item.includes_list?.find(
        (inc) =>
          inc.configId === configId && inc.dataPointId === item.dataPointId,
      );

      return [
        {
          ...item,
          selected: matchedInclude?.selected ?? item.selected ?? false,
        },
      ];
    })
    .map(({ includes_list, exception_list, ...rest }) => rest);
}

export function getSelectedItemsFromCollectors(collectorConfigs, pipeUpdate) {
  const collectorConfigsArray = Object.values(collectorConfigs);
  return collectorConfigsArray[0].map((collectorConfig) => {
    const selectedCollectorConfig = {
      configId: collectorConfig.configId,
    };

    // --- general section ---
    if (collectorConfig.general) {
      const general = {};
      if (Array.isArray(collectorConfig.general.eventList)) {
        general.events = collectorConfig.general.eventList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({
            id: item?.dataPointId,
            selectedMediaType:
              item?.mediaType ||
              item?.datapointsList?.[0]?.mediaTypeName ||
              item?.additional_info?.[0]?.mediaType,
          }));
      }

      if (Array.isArray(collectorConfig.general.fluxDataList)) {
        general.fluxdata = collectorConfig.general.fluxDataList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.general.metaDataList)) {
        general.metadata = collectorConfig.general.metaDataList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      selectedCollectorConfig.general = general;
    }

    // --- mediaPlayer section ---
    if (collectorConfig.mediaPlayer) {
      const mediaPlayer = {};

      if (Array.isArray(collectorConfig.mediaPlayer.eventList)) {
        mediaPlayer.events = collectorConfig.mediaPlayer.eventList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({
            id: item?.dataPointId,
            selectedMediaType:
              item?.mediaType ||
              item?.datapointsList?.[0]?.mediaTypeName ||
              item?.additional_info?.[0]?.mediaType,
          }));
      }

      if (Array.isArray(collectorConfig.mediaPlayer.fluxDataList)) {
        mediaPlayer.fluxdata = collectorConfig.mediaPlayer.fluxDataList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.mediaPlayer.metaDataList)) {
        mediaPlayer.metadata = collectorConfig.mediaPlayer.metaDataList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      // Only include mediaPlayer if it has data
      if (
        (mediaPlayer.events && mediaPlayer.events.length > 0) ||
        (mediaPlayer.fluxdata && mediaPlayer.fluxdata.length > 0) ||
        (mediaPlayer.metadata && mediaPlayer.metadata.length > 0)
      ) {
        selectedCollectorConfig.mediaPlayer = mediaPlayer;
      }
    }

    // --- custom section ---
    if (Array.isArray(collectorConfig.custom)) {
      if (collectorConfig.custom?.length > 0) {
        selectedCollectorConfig.custom = collectorConfig?.custom;
      }
    }

    // --- vendor section ---
    if (Array.isArray(collectorConfig.vendor)) {
      if (collectorConfig.vendor.length > 0) {
        selectedCollectorConfig.vendor = collectorConfig?.vendor;
      }
    }

    // Alias section
    if (collectorConfig.alias) {
      const customDetectedDataPoint = {};

      if (Array.isArray(collectorConfig.alias.event)) {
        customDetectedDataPoint.event = collectorConfig.alias.event
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.alias.metadata)) {
        customDetectedDataPoint.metadata = collectorConfig.alias.metadata
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      // Only include alias if it has data
      if (
        (customDetectedDataPoint.event &&
          customDetectedDataPoint.event.length > 0) ||
        (customDetectedDataPoint.metadata &&
          customDetectedDataPoint.metadata.length > 0)
      ) {
        selectedCollectorConfig.alias = customDetectedDataPoint;
      }
    }

    return selectedCollectorConfig;
  });
}

export function getSelectedItemsFromCollectorsForCreate(
  collectorConfigs,
  create,
) {
  return collectorConfigs?.map((collectorConfig) => {
    const selectedCollectorConfig = {
      configId: collectorConfig.configId,
    };
    const general = {};
    if (collectorConfig.general) {
      if (Array.isArray(collectorConfig.general.eventList)) {
        general.eventsList = collectorConfig.general.eventList
          .filter((item) => item && Array.isArray(item.datapointsList))
          .flatMap((item) =>
            item.datapointsList.map((dp) => ({
              id: dp?.id || dp.dataPointId,
              selectedMediaType: dp?.mediaTypeName,
            })),
          );
      }

      if (Array.isArray(collectorConfig.general.fluxDataList)) {
        general.fluxDataList = collectorConfig.general.fluxDataList
          .filter((item) => item?.name)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.general.metaDataList)) {
        general.metaDataList = collectorConfig.general.metaDataList
          .filter((item) => item?.name)
          .map((item) => ({ id: item.dataPointId }));
      }
    }
    selectedCollectorConfig.general = general;
    // --- mediaPlayer section ---
    if (collectorConfig.mediaPlayer) {
      const mediaPlayer = {};

      if (Array.isArray(collectorConfig.mediaPlayer.eventList)) {
        mediaPlayer.eventsList = collectorConfig.mediaPlayer.eventList
          .filter((item) => item && Array.isArray(item.datapointsList))
          .flatMap((item) =>
            item.datapointsList.map((dp) => ({
              id: dp?.id || dp.dataPointId,
              selectedMediaType: dp?.mediaTypeName,
            })),
          );
      }

      if (Array.isArray(collectorConfig.mediaPlayer.fluxDataList)) {
        mediaPlayer.fluxDataList = collectorConfig.mediaPlayer.fluxDataList
          .filter((item) => item?.name)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.mediaPlayer.metaDataList)) {
        mediaPlayer.metaDataList = collectorConfig.mediaPlayer.metaDataList
          .filter((item) => item?.name)
          .map((item) => ({ id: item.dataPointId }));
      }

      // Only include mediaPlayer if it has data
      if (
        (mediaPlayer.eventsList && mediaPlayer.eventsList.length > 0) ||
        (mediaPlayer.fluxDataList && mediaPlayer.fluxDataList.length > 0) ||
        (mediaPlayer.metaDataList && mediaPlayer.metaDataList.length > 0)
      ) {
        selectedCollectorConfig.mediaPlayer = mediaPlayer;
      }
    }

    // --- custom section ---
    if (
      Array.isArray(collectorConfig.custom) &&
      collectorConfig.custom.length > 0
    ) {
      selectedCollectorConfig.custom = collectorConfig.custom.map((item) => ({
        id: item.dataPointId,
      }));
    }

    // --- vendor section ---
    if (
      Array.isArray(collectorConfig.vendor) &&
      collectorConfig.vendor.length > 0
    ) {
      selectedCollectorConfig.vendor = collectorConfig.vendor.map((item) => ({
        id: item.dataPointId,
      }));
    }

    // Alias section
    if (collectorConfig.alias) {
      const customDetectedDataPoint = {};

      if (Array.isArray(collectorConfig.alias.events)) {
        customDetectedDataPoint.event = collectorConfig.alias.events
          .filter((item) => item?.name)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.alias.metadata)) {
        customDetectedDataPoint.metadata = collectorConfig.alias.metadata
          .filter((item) => item?.name)
          .map((item) => ({ id: item.dataPointId }));
      }

      // Only include alias if it has data
      if (
        (customDetectedDataPoint.event &&
          customDetectedDataPoint.event.length > 0) ||
        (customDetectedDataPoint.metadata &&
          customDetectedDataPoint.metadata.length > 0)
      ) {
        selectedCollectorConfig.alias = customDetectedDataPoint;
      }
    }
    return selectedCollectorConfig;
  });
}

export function getSelectedItemsFromCollectorsForTabZeroUpdate(
  collectorConfigs,
  create,
) {
  return collectorConfigs?.map((collectorConfig) => {
    const selectedCollectorConfig = {
      configId: collectorConfig.configId,
    };

    // --- general section ---
    if (collectorConfig.general) {
      const general = {};
      if (Array.isArray(collectorConfig.general.eventList)) {
        general.events = collectorConfig.general.eventList.flatMap((item) => {
          if (Array.isArray(item.datapointsList)) {
            return item.datapointsList
              .filter((dp) => dp?.selected || dp?.required)
              .map((dp) => ({
                id: dp?.id || dp?.dataPointId,
                selectedMediaType: dp?.mediaTypeName,
              }));
          }

          if (item?.selected || item?.required) {
            return [
              {
                id: item?.dataPointId,
                selectedMediaType:
                  item?.mediaType ||
                  item?.datapointsList?.[0]?.mediaTypeName ||
                  item?.additional_info?.[0]?.mediaType,
              },
            ];
          }

          return [];
        });
      }

      if (Array.isArray(collectorConfig.general.fluxDataList)) {
        general.fluxdata = collectorConfig.general.fluxDataList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.general.metaDataList)) {
        general.metadata = collectorConfig.general.metaDataList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      selectedCollectorConfig.general = general;
    }

    // --- mediaPlayer section ---
    if (collectorConfig.mediaPlayer) {
      const mediaPlayer = {};

      if (Array.isArray(collectorConfig.mediaPlayer.eventList)) {
        mediaPlayer.events = collectorConfig.mediaPlayer.eventList.flatMap(
          (item) => {
            if (Array.isArray(item.datapointsList)) {
              return item.datapointsList
                .filter((dp) => dp?.selected || dp?.required)
                .map((dp) => ({
                  id: dp?.id || dp?.dataPointId,
                  selectedMediaType: dp?.mediaTypeName,
                }));
            }

            if (item?.selected || item?.required) {
              return [
                {
                  id: item?.dataPointId,
                  selectedMediaType:
                    item?.mediaType ||
                    item?.datapointsList?.[0]?.mediaTypeName ||
                    item?.additional_info?.[0]?.mediaType,
                },
              ];
            }

            return [];
          },
        );
      }

      if (Array.isArray(collectorConfig.mediaPlayer.fluxDataList)) {
        mediaPlayer.fluxdata = collectorConfig.mediaPlayer.fluxDataList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.mediaPlayer.metaDataList)) {
        mediaPlayer.metadata = collectorConfig.mediaPlayer.metaDataList
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      // Only include mediaPlayer if it has data
      if (
        (mediaPlayer.events && mediaPlayer.events.length > 0) ||
        (mediaPlayer.fluxdata && mediaPlayer.fluxdata.length > 0) ||
        (mediaPlayer.metadata && mediaPlayer.metadata.length > 0)
      ) {
        selectedCollectorConfig.mediaPlayer = mediaPlayer;
      }
    }

    // --- custom section ---
    if (
      Array.isArray(collectorConfig.custom) &&
      collectorConfig.custom.length > 0
    ) {
      const selectedCustom = collectorConfig.custom
        .filter((item) => item.selected || item.required)
        .map((item) => ({
          id: item.dataPointId,
        }));

      if (selectedCustom?.length > 0) {
        selectedCollectorConfig.custom = selectedCustom;
      }
    }

    // --- vendor section ---
    if (
      Array.isArray(collectorConfig.vendor) &&
      collectorConfig.vendor.length > 0
    ) {
      const selectedVendor = collectorConfig.vendor
        .filter((item) => item.selected || item.required)
        .map((item) => ({
          id: item.dataPointId,
        }));

      if (selectedVendor?.length > 0) {
        selectedCollectorConfig.vendor = selectedVendor;
      }
    }

    // Alias section
    if (collectorConfig.alias) {
      const customDetectedDataPoint = {};

      if (Array.isArray(collectorConfig.alias.events)) {
        customDetectedDataPoint.event = collectorConfig.alias.events
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.alias.metadata)) {
        customDetectedDataPoint.metadata = collectorConfig.alias.metadata
          .filter((item) => item?.selected || item?.required)
          .map((item) => ({ id: item.dataPointId }));
      }

      // Only include alias if it has data
      if (
        (customDetectedDataPoint.event &&
          customDetectedDataPoint.event.length > 0) ||
        (customDetectedDataPoint.metadata &&
          customDetectedDataPoint.metadata.length > 0)
      ) {
        selectedCollectorConfig.alias = customDetectedDataPoint;
      }
    }
    return selectedCollectorConfig;
  });
}
export const getUniqueMetadataCount = (data) => {
  const allMetadata = [
    ...(data?.allMetadata || []),
    ...(data?.applicationMetadata || []),
    ...(data?.cdnMetadata || []),
  ];

  const uniqueSet = new Set();

  allMetadata?.forEach((item) => {
    const name = item?.name;
    const groupOrType = item?.group || item?.type;
    const isRequired = item?.required;
    const includesSelected = item?.includes_list?.some((i) => i?.selected);
    if ((isRequired || includesSelected) && name && groupOrType) {
      const key = JSON.stringify({ name, group: groupOrType });
      uniqueSet.add(key);
    }
  });

  return uniqueSet?.size || 0;
};

export const getUniqueFluxdataCount = (data) => {
  const uniqueSet = new Set();
  data?.forEach((item) => {
    const name = item?.dataPointId;
    const isRequired = item?.required;
    const includesSelected = item?.includes_list?.some((i) => i?.selected);
    if ((isRequired || includesSelected) && name) {
      uniqueSet.add(name);
    }
  });

  return uniqueSet?.size || 0;
};

export const getSelectedUniqueEventsCount = (...eventList) => {
  const uniqueSet = new Set();
  eventList?.forEach((item) => {
    const name = item?.name;
    const isRequired = item?.required;
    const includesSelected = item?.includes_list?.some((i) => i?.selected);
    const additionalInfoSelected = item?.additional_info?.some(
      (i) => i?.selected,
    );

    if ((isRequired || includesSelected || additionalInfoSelected) && name) {
      uniqueSet.add(name);
    }
  });

  return uniqueSet?.size || 0;
};

function filterCollectorListsByType(item, type) {
  const isAppType = type === "application";
  const shouldKeep = (collector) =>
    isAppType
      ? collector?.collectorType === "APP_COLLECTOR"
      : collector?.collectorType === "CDN";
  const filteredIncludes = item?.includes_list?.filter(shouldKeep);
  const filteredExceptions = item?.exception_list?.filter(shouldKeep);
  const anySelectedOrRequired = filteredIncludes?.some(
    (entry) => entry?.selected === true || entry?.required === true,
  );
  return {
    ...item,
    includes_list: filteredIncludes,
    exception_list: filteredExceptions,
    selected: anySelectedOrRequired,
  };
}

// Utility function to update item selection based on matching criteria
const updateSelectionStatus = (itemsList, referenceData) => {
  if (itemsList?.length > 0 && referenceData?.length > 0) {
    itemsList.forEach((item) => {
      const match = referenceData.find(
        (dp) => dp.dataPointId === item.dataPointId && !dp.required,
      );
      if (match) {
        item.selected = match.selected;
      }
    });
  }
};

const updateCustomOrVendorSelectionStatus = (itemsList, referenceData) => {
  if (Array.isArray(itemsList) && Array.isArray(referenceData)) {
    itemsList.forEach((item) => {
      const match = referenceData.find(
        (dp) => dp.dataPointId === item.dataPointId && !dp.required,
      );
      if (match) {
        item.selected = match.selected;
      }
    });
  }
};

// Main function
export const updateSelecteionOnCollectorAddInAllSections = (
  currentCollectorConfigs,
  player,
  auth,
) => {
  const datapoints = extractLists(
    currentCollectorConfigs,
    {},
    "general",
    true,
    auth,
  );
  // Events section
  updateAllEventDatapointsSelection(player, datapoints);
  // fluxdata general section
  updateSelectionStatus(player?.general?.fluxDataList, datapoints?.fluxdata);
  // fluxdata mediaplayer section
  updateSelectionStatus(
    player?.mediaPlayer?.fluxDataList,
    datapoints?.fluxdata,
  );
  // metdata general and mediaplayer section app collector
  updateSelectionStatus(player?.general?.metaDataList, [
    ...datapoints.metadata.applicationMetadata,
    ...datapoints.metadata.cdnMetadata,
  ]);
  updateSelectionStatus(player?.mediaPlayer?.metaDataList, [
    ...datapoints.metadata.applicationMetadata,
    ...datapoints.metadata.cdnMetadata,
  ]);
  // update custom selection status
  updateCustomOrVendorSelectionStatus(player?.custom, [
    ...datapoints.event,
    ...datapoints.metadata.applicationMetadata,
    ...datapoints.metadata.cdnMetadata,
  ]);
  // update vendor selection status
  updateCustomOrVendorSelectionStatus(player?.vendor, [
    ...datapoints.event,
    ...datapoints.metadata.applicationMetadata,
    ...datapoints.metadata.cdnMetadata,
  ]);
  // update alias event selection status
  updateSelectionStatus(player?.alias?.events, datapoints?.alias?.event);
  // update alias metdata  selection status
  updateSelectionStatus(player?.alias?.metadata, [
    ...datapoints.metadata.applicationMetadata,
    ...datapoints.metadata.cdnMetadata,
  ]);
  return player;
};

const updateAllEventDatapointsSelection = (player, datapoints) => {
  const sections = ["general", "mediaPlayer"];
  sections.forEach((section) => {
    const eventList = player?.[section]?.eventList;
    if (Array.isArray(eventList) && Array.isArray(datapoints?.event)) {
      eventList.forEach((eventItem) => {
        if (Array.isArray(eventItem.datapointsList)) {
          eventItem.datapointsList.forEach((dpItem) => {
            const match = datapoints.event.find(
              (dp) =>
                Array.isArray(dp.additional_info) &&
                dp.additional_info.some(
                  (info) => info.dataPointId === dpItem.id,
                ),
            );
            if (match) {
              const matchedInfo = match.additional_info.find(
                (info) => info.dataPointId === dpItem.id,
              );

              if (matchedInfo) {
                dpItem.selected = matchedInfo.selected;
                eventItem.selected = matchedInfo.selected;
              }
            }
            if (dpItem?.required || dpItem?.selected) {
              eventItem.selected = true;
            }
          });
        }
      });
    }
  });
};
export const getSortData = (data) => {
  if (!data) return { label: "Recent", value: 0 };

  const label = data.orderValue === "0" ? "Recent" : "A-Z";
  const value = data.fieldValue === "configName" ? "1" : data.fieldValue;

  return [{ label, value }];
};

export const dataPipeToggleIcon = (sectionName) => [
  { icon: <LibraryBooksIcon />, value: 0, name: `${sectionName} Details` },
  {
    icon: <HistoryIcon />,
    value: 1,
    name: "Change Log",
  },
];

export const dataPipeChangeTblLog = [
  {
    key: "Field",
    label: "Change Type",
  },
  {
    key: "Previous_Value",
    label: "Previous Value",
  },
  {
    key: "Empty_Value",
    label: "",
  },
  {
    key: "New_Value",
    label: "New Value",
  },
];

export const getDataPointsTableTitle = (collecorConfigs) => {
  const uniqueCollectorTypes = [
    ...new Set(collecorConfigs.map((c) => c.collectorType)),
  ];
  const result = [];

  result.push({
    key: "labelDp",
    label: "Name",
    sortable: true,
    sortKey: "labelDp",
    width: "30%",
  });

  result.push({
    key: "type",
    label: "Type",
    sortable: true,
    sortKey: "type",
    width: "10%",
  });
  result.push({
    key: "dictionary",
    label: "dictionary",
    sortable: true,
    sortKey: "dictionary",
    width: "20%",
  });

  result.push({
    key: "groupCategory",
    label: "Metadata category",
    sortable: true,
    sortKey: "groupCategory",
    width: "25%",
  });

  result.push({
    key: "required",
    label: "required",
    sortable: true,
    sortKey: "required",
    width: "10%",
  });
  return result;
};

export const getDataPointRows = (
  dataPoints,
  selectedFilterPopOver,
  sortConfig,
  query,
  datapointMappingDetails,
  overrideValue,
) => {
  if (!dataPoints?.length) return [];
  const oldDataPoints = dataPoints?.map((dp) =>
    mapDataPoint(dp, overrideValue),
  );
  const mappedRows = dataPoints?.map((dp) => mapDataPoint(dp, overrideValue));
  let rows = [...mappedRows];

  if (selectedFilterPopOver?.length) {
    const filterGroups = selectedFilterPopOver.reduce((acc, f) => {
      (acc[f.key] ||= []).push(
        f?.type === "groupCategory"
          ? f?.name?.split("Metadata")?.[0]?.trim()
          : f?.name,
      );
      return acc;
    }, {});
    rows = rows.filter((dp) =>
      Object.entries(filterGroups).every(([key, values]) =>
        values.some((val) => {
          const dpValue = dp?.[key]?.value ?? "--";

          if (val === "Yes") return dpValue === "Yes";
          if (val === "No") return dpValue === "No";

          if (key === "source") {
            if (val === "Application") return dpValue === "Application";
            if (val === "CDN") return dpValue === "CDN";
          }

          if (key === "type" && val === "Filtered Event") {
            return (
              dp?.labelDp?.mediaType === "ad" ||
              dp?.labelDp?.mediaType === "content"
            );
          }
          if (key === "isException" && val === "Exception") {
            return dp?.isException === true;
          }

          if (key === "supported" && val === "Selected") {
            return dp?.supported?.value === "Yes";
          }

          if (key === "supported" && val === "Unselected") {
            return dp?.supported?.value === "No";
          }

          if (key === "isException" && val === "No Exception") {
            return dp?.isException === false;
          }
          if (val === "(Blanks)") {
            if (process.env.REACT_APP_NEW_DATAPOINT_TABLE_V2 === "true") {
              return (
                val === "(Blanks)" &&
                (dp?.type?.value === "Metadata" ||
                  filterGroups?.type?.some((t) => t === dp?.type?.value) ||
                  filterGroups?.type?.some((t) => t === dp?.type?.value))
              );
            }
            return dpValue === "--";
          }

          return dpValue === val;
        }),
      ),
    );
  }

  if (query?.trim()) {
    const q = query.toLowerCase();
    rows = rows.filter(
      (dp) =>
        dp.labelDp?.value?.toLowerCase().includes(q) ||
        dp.group?.value?.toLowerCase().includes(q) ||
        dp.labelDp?.tooltipName?.toLowerCase().includes(q),
    );
  }

  if (sortConfig?.sortBy) {
    const { sortBy, sortOrder } = sortConfig;
    rows.sort((a, b) => {
      const valA = (a?.[sortBy]?.value ?? "--").toString().toLowerCase();
      const valB = (b?.[sortBy]?.value ?? "--").toString().toLowerCase();

      return sortOrder ? valA.localeCompare(valB) : valB.localeCompare(valA);
    });
  }
  if (process.env.REACT_APP_NEW_DATAPOINT_TABLE_V2 === "true") {
    return rows;
  }
  const updatedRows = updateDependatantMetaSelection(
    rows,
    datapointMappingDetails,
    oldDataPoints,
  );
  return updatedRows;
};

// mapping helper
const mapDataPoint = (dataPoint, overrideValue) => {
  const required = !!dataPoint?.required;
  // if not required, check includesList
  const hasSelectedInIncludes =
    Array.isArray(dataPoint?.includesList) &&
    dataPoint.includesList.some((inc) => inc?.selected);

  const supportedValue =
    hasSelectedInIncludes || dataPoint?.required === true ? "Yes" : "No";
  const restrictedDictionaries = ["Video Player v.2", "CDN v.3"];
  const isEditableLabel =
    (dataPoint?.label === "Heartbeat" ||
      dataPoint?.label === "Milestone" ||
      dataPoint?.label === "Qualified View") &&
    !restrictedDictionaries?.some((name) =>
      dataPoint?.dictionaryName?.includes(name),
    );

  let editDisplayValue = "";
  if (dataPoint?.label === "Heartbeat") {
    editDisplayValue = `${
      overrideValue?.playHeadFrequency
        ? overrideValue?.playHeadFrequency
        : process.env.REACT_APP_NEW_DATAPOINT_TABLE_V2 === "true"
        ? 60
        : ""
    } ${
      overrideValue?.playHeadFrequency
        ? "seconds"
        : process.env.REACT_APP_NEW_DATAPOINT_TABLE_V2 === "true"
        ? "seconds"
        : ""
    }`;
  } else if (dataPoint?.label === "Milestone") {
    if (dataPoint?.mediaType === "ad") {
      const msAdLength =
        overrideValue?.msAd?.split(",")?.filter(Boolean).length || 0;
      editDisplayValue =
        msAdLength > 0
          ? `${msAdLength} ${msAdLength > 1 ? "triggers" : "trigger"}`
          : process.env.REACT_APP_NEW_DATAPOINT_TABLE_V2 === "true"
          ? "3 triggers"
          : "";
    } else if (dataPoint?.mediaType === "content") {
      const msContentLength =
        overrideValue?.msContent?.split(",")?.filter(Boolean).length || 0;
      editDisplayValue =
        msContentLength > 0
          ? `${msContentLength} ${msContentLength > 1 ? "triggers" : "trigger"}`
          : process.env.REACT_APP_NEW_DATAPOINT_TABLE_V2 === "true"
          ? "7 triggers"
          : "";
    }
  } else if (dataPoint?.label === "Qualified View") {
    if (dataPoint?.mediaType === "ad") {
      const qvAdLength =
        overrideValue?.qvAd?.split(",")?.filter(Boolean).length || 0;
      editDisplayValue =
        qvAdLength > 0
          ? `${qvAdLength} ${qvAdLength > 1 ? "triggers" : "trigger"}`
          : process.env.REACT_APP_NEW_DATAPOINT_TABLE_V2 === "true"
          ? "1 triggers"
          : "";
    } else if (dataPoint?.mediaType === "content") {
      const qvContentLength =
        overrideValue?.qvContent?.split(",")?.filter(Boolean).length || 0;
      editDisplayValue =
        qvContentLength > 0
          ? `${qvContentLength} ${qvContentLength > 1 ? "triggers" : "trigger"}`
          : process.env.REACT_APP_NEW_DATAPOINT_TABLE_V2 === "true"
          ? "2 triggers"
          : "";
    }
  }

  return {
    labelDp: {
      value: dataPoint?.label ?? "--",
      supported: supportedValue,
      isEditableLabel,
      editDisabled: supportedValue === "No",
      ...(isEditableLabel === true && { editDisplayValue }),
      dictionary: dataPoint?.dictionary ?? "--",
      mediaType: dataPoint?.mediaType,
      tooltipName:
        dataPoint?.dictionary?.toLowerCase() === "custom" &&
        dataPoint?.type === "Event"
          ? `"custom_ ${dataPoint?.name}"`
          : `"${dataPoint?.name}"`,
    },
    type: { value: dataPoint?.type ?? "--" },
    dictionary: { value: dataPoint?.dictionary ?? "--" },
    method: { value: "--" },
    groupCategory: { value: dataPoint?.group ?? "--" },
    required: { value: required ? "Yes" : "No" },
    supported: { value: supportedValue },
    source: {
      value: dataPoint?.collectorType,
    },
    exception_list: Array.isArray(dataPoint?.exceptionList)
      ? dataPoint.exceptionList.filter(
          (item) => item?.collectorType === dataPoint?.collectorType,
        )
      : [],
    datapointId: dataPoint?.dataPointId,
    disabled: dataPoint?.disabled || false,
    originalSupported: { value: supportedValue },
    deprecated: dataPoint?.deprecated,
    isException:
      Array.isArray(dataPoint?.exceptionList) &&
      dataPoint?.exceptionList?.some(
        (item) => item?.collectorType === dataPoint?.collectorType,
      ),
  };
};

const updateDependatantMetaSelection = (
  rows = [],
  datapointMappingDetails = [],
  oldDataPoints = [],
) => {
  if (!datapointMappingDetails.length || !rows.length) return rows;

  // Build label lookup for both current and old datapoints
  const buildLabelMap = (list) =>
    list.reduce((acc, row) => {
      const key = row?.labelDp?.value?.trim().toLowerCase();
      if (!acc[key]) acc[key] = [];
      acc[key].push(row);
      return acc;
    }, {});

  const currentLabelMap = buildLabelMap(rows);
  const oldLabelMap = buildLabelMap(oldDataPoints);

  datapointMappingDetails.forEach((dict) => {
    dict.metadataMappings?.forEach(({ metadata, events }) => {
      const metadataKey = metadata?.trim()?.toLowerCase();
      const affectedRows = currentLabelMap[metadataKey] || [];

      affectedRows.forEach((metaRow) => {
        if (
          metaRow.type?.value !== "Metadata" ||
          !metaRow.dictionary?.value ||
          metaRow.dictionary?.value?.trim() !== dict.dictionary?.trim()
        ) {
          return;
        }

        const dependentEvents = [];

        // Check dependent event rows (from oldDataPoints first)
        events?.forEach((eventLabel) => {
          const eventKey = eventLabel?.trim()?.toLowerCase();

          const eventRows =
            oldLabelMap[eventKey] || currentLabelMap[eventKey] || [];

          eventRows.forEach((evRow) => {
            if (
              evRow.type?.value === "Event" &&
              evRow.dictionary?.value?.trim() === dict.dictionary?.trim()
            ) {
              dependentEvents.push(evRow);
            }
          });
        });

        // Determine if any related event is supported
        const anySupportedYes = dependentEvents.some(
          (ev) => ev.supported?.value === "Yes",
        );

        if (dependentEvents?.length) {
          metaRow.originalSupported = { value: metaRow.supported.value };
          metaRow.supported.value = anySupportedYes ? "Yes" : "No";
          if (metaRow?.groupCategory?.value) {
            const dependentEventLabels = dependentEvents
              ?.map((ev) => ev?.labelDp?.value)
              ?.filter(Boolean)
              ?.join(", ");

            metaRow.groupCategory.additionalValue = `Attribute of ${dependentEventLabels} Event`;
          }
        }
      });
    });
  });

  return rows;
};

export const getAllDataPoints = (
  configList,
  datapointMappingDetails,
  roleName,
) => {
  const dataPointMap = new Map();

  const allConfigs = configList.map((c) => ({
    configId: c?.configId || c?.id,
    configName: c?.configName,
    collectorId: c?.collectorId,
    collectorName: c?.collectorName,
    collectorType: c?.collectorType,
    collectorIcon: c?.collectorIcon,
    pluginId: c?.pluginId,
    pluginName: c?.pluginName,
    pluginIcon: c?.pluginIcon,
    adFrameworkName: c?.adFrameworkName || null,
    disabled: c?.disabled,
  }));

  const getContext = (mediaType) => {
    if (mediaType === "ad") return "Ad framework";
    if (mediaType === "content") return "Media Player";
    return "Global";
  };

  const capitalizeType = (val) =>
    val ? val.charAt(0).toUpperCase() + val.slice(1).toLowerCase() : val;

  const deriveTypeAndOriginal = (dp, baseType, section) => {
    if (section === "custom" || section === "vendor") {
      if (dp.name?.toLowerCase().includes("event")) {
        return { type: "Event", originalType: section };
      }
      if (dp.name?.toLowerCase().includes("metadata")) {
        return { type: "Metadata", originalType: section };
      }
      return { type: capitalizeType(baseType), originalType: section };
    }
    return { type: capitalizeType(baseType) };
  };

  const collect = (list, configMeta, baseType, section) => {
    if (!Array.isArray(list)) return;
    list.forEach((dp) => {
      if (!dp?.dataPointId) return;
      const { type, originalType } = deriveTypeAndOriginal(
        dp,
        baseType,
        section,
      );
      if (!dataPointMap.has(dp.dataPointId)) {
        dataPointMap.set(dp.dataPointId, {
          ...dp,
          group: dp.group || "--",
          type,
          section,
          collectorType: configMeta.collectorType,
          method: "--",
          ...(originalType ? { originalType } : {}),
          dictionary: dp?.dictionaryName || "Custom",
          includesList: [],
          exceptionList: [],
          originalSupported: dp?.selected,
        });
      }
      const existing = dataPointMap.get(dp.dataPointId);
      const includeObj = {
        ...configMeta,
        type,
        section,
        selected: dp.selected ?? false,
        required: dp.required ?? false,
        method: "--",
        ...(originalType ? { originalType } : {}),
        ...(type === "Event"
          ? {
              mediaType: dp.mediaType || null,
              dictionary: dp?.dictionaryName || "Custom",
            }
          : { dictionary: dp?.dictionaryName || "Custom" }),
      };
      if (
        !existing.includesList.some(
          (i) =>
            i.configId === configMeta.configId &&
            i.type === type &&
            i.section === section,
        )
      ) {
        existing.includesList.push(includeObj);
      }
    });
  };

  configList.forEach((configObj) => {
    const configMeta = allConfigs.find(
      (c) => c.configId === (configObj.configId || configObj.id),
    );
    if (configObj.general) {
      collect(configObj.general.eventList, configMeta, "Event", "general");
      collect(
        configObj.general.fluxDataList,
        configMeta,
        "Fluxdata",
        "general",
      );
      collect(
        configObj.general.metaDataList,
        configMeta,
        "Metadata",
        "general",
      );
    }
    if (configObj.mediaPlayer) {
      collect(
        configObj.mediaPlayer.eventList,
        configMeta,
        "Event",
        "mediaPlayer",
      );
      collect(
        configObj.mediaPlayer.fluxDataList,
        configMeta,
        "Fluxdata",
        "mediaPlayer",
      );
      collect(
        configObj.mediaPlayer.metaDataList,
        configMeta,
        "Metadata",
        "mediaPlayer",
      );
    }
    collect(configObj.custom, configMeta, "Custom", "custom");
    if (configObj.alias) {
      collect(configObj.alias.events, configMeta, "Event", "alias");
      collect(configObj.alias.metadata, configMeta, "Metadata", "alias");
    }
    collect(configObj.vendor, configMeta, "Vendor", "vendor");
  });

  dataPointMap.forEach((dp) => {
    dp.group = dp.group || "--";
    const includedKeys = dp.includesList.map(
      (i) => `${i.configId}:${i.type}:${i.section}`,
    );
    dp.exceptionList = [];
    allConfigs.forEach((configMeta) => {
      const key = `${configMeta.configId}:${dp.type}:${
        dp.section || "unknown"
      }`;
      if (!includedKeys.includes(key)) {
        dp.exceptionList.push({
          ...configMeta,
          type: dp.type,
          section: dp.section || "unknown",
          selected: false,
          required: false,
          method: "--",
          dataPointId: null,
          mediaType: "not_appl",
          ...(dp.originalType ? { originalType: dp.originalType } : {}),
          ...(dp.type === "Event"
            ? { dictionary: dp?.dictionaryName || "Custom" }
            : { dictionary: dp?.dictionaryName || "Custom" }),
        });
      }
    });
  });
  const sortedDataPoints = Array.from(dataPointMap.values()).sort((a, b) => {
    const labelA = (a.label || "").toLowerCase();
    const labelB = (b.label || "").toLowerCase();
    return labelA.localeCompare(labelB);
  });
  let disabledUpdatedDataPoints = updatedDisableForDataPointTable(
    sortedDataPoints,
    datapointMappingDetails,
  );

  let result = disabledUpdatedDataPoints;

  if (
    process.env.REACT_APP_NEW_DATAPOINT_TABLE_V2 === "true" &&
    roleName === SUPER_ADMIN_ROLE
  ) {
    const isRemoved = (item) =>
      item?.deprecated === true &&
      item?.selected === false &&
      item?.required === false;
    result = result?.filter((item) => !isRemoved(item));
  }

  // if (
  //   process.env.REACT_APP_NEW_DATAPOINT_TABLE_V2 === "true" &&
  //   roleName !== SUPER_ADMIN_ROLE
  // ) {
  //   result = result?.filter((item) => item?.omitFromUi !== true);
  // }

  return result;
};

export const updateConfigsSelectedForDataPointTable = (
  configs,
  updatedDataPoints,
) => {
  const includeMap = new Map();

  updatedDataPoints.forEach((dp) => {
    dp.includesList?.forEach((inc) => {
      if (dp.dataPointId && inc.configId != null) {
        includeMap.set(`${dp.dataPointId}|${inc.configId}`, {
          selected: inc.selected,
          required: inc.required,
        });
      }
    });
  });

  const updateIncludesList = (list = [], configId) =>
    list.map((item) => {
      const key = `${item.dataPointId}|${configId}`;
      if (includeMap.has(key)) {
        const { selected, required } = includeMap.get(key);
        if (required) return item;
        return { ...item, selected };
      }
      return item;
    });

  return configs.map((config) => {
    const cfgId = config.configId;

    if (config.general) {
      config.general.eventList = updateIncludesList(
        config.general?.eventList,
        cfgId,
      );
      config.general.fluxDataList = updateIncludesList(
        config.general?.fluxDataList,
        cfgId,
      );
      config.general.metaDataList = updateIncludesList(
        config.general?.metaDataList,
        cfgId,
      );
    }

    if (config.mediaPlayer) {
      config.mediaPlayer.eventList = updateIncludesList(
        config.mediaPlayer?.eventList,
        cfgId,
      );
      config.mediaPlayer.fluxDataList = updateIncludesList(
        config.mediaPlayer?.fluxDataList,
        cfgId,
      );
      config.mediaPlayer.metaDataList = updateIncludesList(
        config.mediaPlayer?.metaDataList,
        cfgId,
      );
    }

    config.custom = updateIncludesList(config.custom, cfgId);

    if (config.alias) {
      config.alias.events = updateIncludesList(config?.alias?.events, cfgId);
      config.alias.metadata = updateIncludesList(
        config?.alias?.metadata,
        cfgId,
      );
    }

    config.vendor = updateIncludesList(config?.vendor, cfgId);
    return config;
  });
};

export const updateCollectorConfigSelectedForDataPointTable = (
  config,
  updatedDataPoints,
) => {
  const map = new Map(
    updatedDataPoints.map((dp) => [dp.dataPointId, dp.selected]),
  );

  function updateList(list = []) {
    list.forEach((item) => {
      if (item?.required) {
        item.selected = true;
      } else if (map.has(item?.dataPointId)) {
        item.selected = map.get(item?.dataPointId);
      }
    });
  }

  if (config?.general) {
    updateList(config?.general?.eventList);
    updateList(config?.general?.fluxDataList);
    updateList(config?.general?.metaDataList);
  }

  if (config?.mediaPlayer) {
    updateList(config?.mediaPlayer?.eventList);
    updateList(config?.mediaPlayer?.metaDataList);
    updateList(config?.mediaPlayer?.fluxDataList);
  }

  updateList(config?.custom);

  if (config?.alias) {
    updateList(config?.alias?.events);
    updateList(config?.alias?.metadata);
  }

  updateList(config?.vendor);
  return config;
};

export const transformConfigs = (configs) => {
  return configs.map((cfg) => {
    const transformed = {
      configId: cfg.configId,
      general: {
        events: (cfg.general?.eventList || [])
          .filter((dp) => dp?.selected || dp?.required)
          .map((dp) => ({
            id: dp?.dataPointId,
            ...(dp?.mediaType ? { selectedMediaType: dp?.mediaType } : {}),
          })),
        fluxdata: (cfg.general?.fluxDataList || [])
          .filter((dp) => dp?.selected || dp?.required)
          .map((dp) => ({ id: dp?.dataPointId })),
        metadata: (cfg.general?.metaDataList || [])
          .filter((dp) => dp?.selected || dp?.required)
          .map((dp) => ({ id: dp?.dataPointId })),
      },
      alias: {
        event: (cfg.alias?.events || [])
          .filter((dp) => dp?.selected || dp?.required)
          .map((dp) => ({ id: dp?.dataPointId })),
        metadata: (cfg.alias?.metadata || [])
          .filter((dp) => dp?.selected || dp?.required)
          .map((dp) => ({ id: dp?.dataPointId })),
      },
    };

    const mediaPlayer = {
      events: (cfg.mediaPlayer?.eventList || [])
        .filter((dp) => dp?.selected || dp?.required)
        .map((dp) => ({
          id: dp?.dataPointId,
          ...(dp?.mediaType ? { selectedMediaType: dp?.mediaType } : {}),
        })),
      fluxdata: (cfg.mediaPlayer?.fluxDataList || [])
        .filter((dp) => dp?.selected || dp?.required)
        .map((dp) => ({ id: dp?.dataPointId })),
      metadata: (cfg.mediaPlayer?.metaDataList || [])
        .filter((dp) => dp?.selected || dp?.required)
        .map((dp) => ({ id: dp?.dataPointId })),
    };

    if (
      mediaPlayer?.events?.length > 0 ||
      mediaPlayer?.fluxdata?.length > 0 ||
      mediaPlayer?.metadata?.length > 0
    ) {
      transformed.mediaPlayer = mediaPlayer;
    }

    const customItems = (cfg.custom || [])
      .filter((dp) => dp?.selected || dp?.required)
      .map((dp) => ({ id: dp?.dataPointId }));

    if (customItems.length > 0) {
      transformed.custom = customItems;
    }

    const vendorItems = (cfg.vendor || [])
      .filter((v) => v.selected || v.required)
      .map((v) => ({
        id: v?.dataPointId,
      }));

    if (vendorItems.length > 0) {
      transformed.vendor = vendorItems;
    }

    return transformed;
  });
};

export const getUniqueDataPointRows = (inputArray, typeKey) => {
  const seen = new Set();
  const skipBlanks = ["selected", "type", "dictionary", "required"].includes(
    typeKey,
  );
  return inputArray
    ?.slice()
    ?.sort((a, b) =>
      (a?.[typeKey]?.value || "")
        .toLowerCase()
        .localeCompare((b?.[typeKey]?.value || "").toLowerCase()),
    )
    .filter((item) => {
      const val = item?.[typeKey]?.value || "--";
      if (skipBlanks && val === "--") return false;
      if (seen.has(val)) return false;
      seen.add(val);
      return true;
    })
    .map((item) => {
      const rawValue = item?.[typeKey]?.value || "--";
      const displayValue = rawValue === "--" ? "(Blanks)" : rawValue;
      return {
        key: typeKey,
        name: displayValue,
        id: `${displayValue}_${typeKey}`,
        type: typeKey,
      };
    });
};

export const mergeFilterItems = (
  currentList = {},
  items = [],
  selectedFilterPopOver = [],
) => {
  const updated = { ...currentList };

  items?.forEach((item) => {
    if (
      ["selected", "type", "Context"].includes(item.type) &&
      item.name === "(Blanks)"
    ) {
      return;
    }

    updated[item.type] = updated[item.type] || [];
    if (!updated[item.type].some((i) => i.id === item.id)) {
      updated[item.type].push(item);
    }
  });

  const allowedTypes = new Set(selectedFilterPopOver.map((f) => f.type));

  Object.keys(updated).forEach((type) => {
    if (!allowedTypes.has(type)) {
      delete updated[type];
    }
  });

  return updated;
};

export const buildFilterConfig = (dataPoints, filterUniqueList = {}) => {
  const filterKeys = [
    { key: "type", name: "Type" },
    { key: "dictionary", name: "Dictionary" },
    { key: "groupCategory", name: "Metadata Category" },
    { key: "supported", name: "Selected" },
  ];

  const DPList = filterKeys
    .map(({ key, name }) => {
      let DPValue;

      if (filterUniqueList?.[key]?.length) {
        DPValue = filterUniqueList[key].map((item) => ({
          id: item.id ?? item.name,
          name: item.name ?? item.id,
          type: key,
        }));
      } else {
        const values = [
          ...new Set(
            dataPoints.map((dp) => {
              const raw = dp?.[key]?.value ?? "--";
              return raw && raw.trim() !== "" ? raw : "(Blanks)";
            }),
          ),
        ];

        DPValue = values.map((val) => ({
          id: val?.trim() === "--" ? "(Blanks)" + `_${key}` : `${val}_${key}`,
          name: val?.trim() === "--" ? "(Blanks)" : val,
          type: key,
        }));
      }

      DPValue.sort((a, b) => a.name.localeCompare(b.name));

      if (["Selected", "type", "dictionary"].includes(name)) {
        DPValue = DPValue?.filter((item) => item?.name !== "(Blanks)");
      }

      if (!DPValue.length) return null;

      return {
        name,
        DPValue,
        quickFilter: true,
      };
    })
    .filter(Boolean);
  return { DPList };
};

export const fixCollectorConfigsOrder = (oldConfigs = [], newConfigs = []) => {
  const reorderByDataPointId = (oldList = [], newList = []) => {
    if (!Array.isArray(newList)) return [];
    if (!Array.isArray(oldList)) return newList;

    const newMap = new Map(newList.map((item) => [item?.dataPointId, item]));

    const ordered = oldList
      .map((oldItem) => newMap.get(oldItem?.dataPointId))
      .filter(Boolean);

    const extras = newList.filter(
      (n) => !oldList.some((o) => o?.dataPointId === n?.dataPointId),
    );

    return [...ordered, ...extras];
  };

  if (!Array.isArray(newConfigs) || !Array.isArray(oldConfigs)) return [];

  return newConfigs.map((newConfig, idx) => {
    const oldConfig = oldConfigs[idx];
    if (!oldConfig) return newConfig;

    const fixedConfig = { ...newConfig };

    if (oldConfig?.general && fixedConfig?.general) {
      fixedConfig.general = { ...fixedConfig?.general };
      fixedConfig.general.eventList = reorderByDataPointId(
        oldConfig.general?.eventList,
        fixedConfig.general?.eventList,
      );
      fixedConfig.general.fluxDataList = reorderByDataPointId(
        oldConfig.general?.fluxDataList,
        fixedConfig.general?.fluxDataList,
      );
      fixedConfig.general.metaDataList = reorderByDataPointId(
        oldConfig.general?.metaDataList,
        fixedConfig.general?.metaDataList,
      );
    }

    if (oldConfig?.mediaPlayer && fixedConfig?.mediaPlayer) {
      fixedConfig.mediaPlayer = { ...fixedConfig.mediaPlayer };
      fixedConfig.mediaPlayer.eventList = reorderByDataPointId(
        oldConfig.mediaPlayer?.eventList,
        fixedConfig.mediaPlayer?.eventList,
      );
      fixedConfig.mediaPlayer.fluxDataList = reorderByDataPointId(
        oldConfig.mediaPlayer?.fluxDataList,
        fixedConfig.mediaPlayer?.fluxDataList,
      );
      fixedConfig.mediaPlayer.metaDataList = reorderByDataPointId(
        oldConfig.mediaPlayer?.metaDataList,
        fixedConfig.mediaPlayer?.metaDataList,
      );
    }

    return fixedConfig;
  });
};

function updatedDisableForDataPointTable(datapoints, datapointMappingDetails) {
  if (
    !Array.isArray(datapoints) ||
    !Array.isArray(datapointMappingDetails) ||
    datapointMappingDetails.length === 0
  ) {
    return datapoints;
  }

  // Build a lookup of all events per dictionary
  const eventLookup = datapoints.reduce((acc, dp) => {
    if (dp.type === "Event") {
      // consider all events, ignore selected
      const dict = dp.dictionary?.trim();
      const label = dp.label?.trim();
      if (dict && label) {
        if (!acc[dict]) acc[dict] = new Set();
        acc[dict].add(label);
      }
    }
    return acc;
  }, {});

  return datapoints.map((dp) => {
    if (dp.type !== "Metadata") return dp;

    // Find the dictionary mapping for this metadata
    const mapping = datapointMappingDetails.find(
      (m) => m.dictionary === dp.dictionary,
    );
    if (!mapping) return dp;

    // Find metadata mapping for this label
    const metaMapping = mapping.metadataMappings?.find(
      (meta) => meta.metadata === dp.label,
    );
    if (!metaMapping) return dp;

    // Check if any dependent event exists in the same dictionary
    const activeEventsInSameDict = eventLookup[dp.dictionary] || new Set();
    const hasDependentEventInSameDict = metaMapping.events?.some((event) =>
      activeEventsInSameDict.has(event),
    );

    return {
      ...dp,
      disabled: hasDependentEventInSameDict ? true : dp.disabled || false,
    };
  });
}

export const addDictionaryToMetadata = (input) => {
  if (!Array.isArray(input)) return [];

  return input.map((dict) => ({
    dictionary: dict.dictionary,
    metadataMappings: dict.metadataMappings.map((meta) => ({
      ...meta,
      dictionary: dict.dictionary,
    })),
  }));
};

export const updateMetaDependancySave = (
  configs,
  updatedDataPoints,
  datapointMappingDetails = [],
) => {
  const includeMap = new Map();
  const oldDataPoints = updatedDataPoints.map(mapDataPoint);

  updatedDataPoints.forEach((dp) => {
    dp.includesList?.forEach((inc) => {
      if (dp.dataPointId && inc.configId != null) {
        includeMap.set(`${dp.dataPointId}|${inc.configId}`, {
          selected: inc.selected,
          required: inc.required,
          type: dp.type,
          label: dp.label,
          dictionaryName: dp.dictionaryName,
          originalSupported: dp?.originalSupported,
        });
      }
    });
  });

  const eventSelectionMap = new Map();
  includeMap.forEach((value, key) => {
    const [dpId, configId] = key.split("|");
    if (value.type === "Event") {
      if (!eventSelectionMap.has(configId)) {
        eventSelectionMap.set(configId, new Map());
      }
      eventSelectionMap.get(configId).set(value.label?.trim(), value.selected);
    }
  });

  const normalize = (str) => (str ? str.trim().toLowerCase() : "");

  const isMetadataSupported = (
    metaLabel,
    dictionary,
    configId,
    originalSupported,
    selected,
  ) => {
    const mapping = datapointMappingDetails?.find(
      (m) => normalize(m?.dictionary) === normalize(dictionary),
    );
    if (!mapping) return selected;

    const metaMap = mapping?.metadataMappings?.find(
      (mm) => normalize(mm?.metadata) === normalize(metaLabel),
    );
    if (!metaMap) return selected;

    const dependentEvents = metaMap?.events || [];
    if (!dependentEvents?.length) return selected;

    const dependentEventDetails = [];
    dependentEvents?.forEach((evLabel) => {
      const key = normalize(evLabel);
      oldDataPoints?.forEach((oldDp) => {
        if (
          oldDp?.type?.value === "Event" &&
          normalize(oldDp?.labelDp?.value) === key
        ) {
          if (normalize(oldDp?.dictionary?.value) === normalize(dictionary)) {
            dependentEventDetails.push({ ...oldDp });
          }
        }
      });
    });

    if (!dependentEventDetails?.length) return selected;

    const anySelected = dependentEventDetails?.some(
      (ev) => ev?.supported?.value === "Yes",
    );

    return anySelected;
  };

  const updateIncludesList = (list = [], configId) =>
    list.map((item) => {
      const key = `${item.dataPointId}|${configId}`;
      if (includeMap.has(key)) {
        const { selected, required, type } = includeMap.get(key);
        if (required) return item;
        return { ...item, selected };
      }
      return item;
    });

  const updateIncludesListForMetadata = (list = [], configId) =>
    list.map((item) => {
      const key = `${item.dataPointId}|${configId}`;
      if (includeMap.has(key)) {
        const {
          selected,
          required,
          type,
          label,
          dictionaryName,
          originalSupported,
        } = includeMap.get(key);

        if (required) return item;

        if (type === "Metadata") {
          const isSupported = isMetadataSupported(
            label,
            dictionaryName,
            configId,
            originalSupported,
            selected,
          );
          return { ...item, selected: isSupported };
        }

        return { ...item, selected };
      }
      return item;
    });

  return configs.map((config) => {
    const cfgId = config.configId;

    if (config.general) {
      config.general.eventList = updateIncludesList(
        config.general?.eventList,
        cfgId,
      );
      config.general.fluxDataList = updateIncludesList(
        config.general?.fluxDataList,
        cfgId,
      );
      config.general.metaDataList = updateIncludesListForMetadata(
        config.general?.metaDataList,
        cfgId,
      );
    }

    if (config.mediaPlayer) {
      config.mediaPlayer.eventList = updateIncludesList(
        config.mediaPlayer?.eventList,
        cfgId,
      );
      config.mediaPlayer.fluxDataList = updateIncludesList(
        config.mediaPlayer?.fluxDataList,
        cfgId,
      );
      config.mediaPlayer.metaDataList = updateIncludesListForMetadata(
        config.mediaPlayer?.metaDataList,
        cfgId,
      );
    }

    config.custom = updateIncludesListForMetadata(config.custom, cfgId);

    if (config.alias) {
      config.alias.events = updateIncludesList(config?.alias?.events, cfgId);
      config.alias.metadata = updateIncludesList(
        config?.alias?.metadata,
        cfgId,
      );
    }

    config.vendor = updateIncludesList(config?.vendor, cfgId);

    return config;
  });
};

export const areAllDisabledOrRequired = (dataPoints = []) => {
  return dataPoints.every((dp) => {
    const isDisabled = dp?.disabled === true;
    const isRequired = dp?.required?.value === "Yes";
    return isDisabled || isRequired;
  });
};

const dataPointOverlayTemplate = {
  heartbeat: {
    title: "Heartbeat - Content Interval",
    subtitle:
      "Within content session, the Heartbeat event fires at the specified interval of time during playback, or right after video playback is interrupted.",
    settingSourceMsg:
      "Choose whether to use the interval specified for your collector or override them for this data pipe.",
    overrideMessage: (
      <>
        NOTE: If you are using{" "}
        <b>
          <i>npm</i>
        </b>{" "}
        and have integrated collectors prior to vX.Y.Z attached to this data
        pipe, they will continue to use the collector-level setting.
      </>
    ),
  },
  milestone: {
    title: "Milestone Interval",
    subtitle:
      "Within [event-media-type] session, the Milestone event fires when the user passes the point for each milestone percentage specified.",
    settingSourceMsg:
      "Choose whether to use triggers specified at the collector level or override them for this data pipe.",
    overrideMessage:
      "NOTE: If you are using npm and have integrated collectors prior to vX.Y.Z attached to this data pipe, they will continue to use the collector-level setting.",
  },
  qualifiedview: {
    title: "Qualified View Interval",
    subtitle:
      "Within [event-media-type] session, the Qualified View event fires when the user passes the point for each qualified percentage specified.",
    settingSourceMsg:
      "Choose whether to use triggers specified at the collector level or override them for this data pipe.",
    overrideMessage:
      "NOTE: If you are using npm and have integrated collectors prior to vX.Y.Z attached to this data pipe, they will continue to use the collector-level setting.",
  },
};

export const getDataPopUpText = (eventType, mediaType) => {
  const normalizedEventType = eventType.replace(/\s+/g, "").toLowerCase();
  const template = dataPointOverlayTemplate[normalizedEventType];
  if (!template) return null;

  let article;
  let { title } = template;

  if (normalizedEventType !== "heartbeat") {
    if (mediaType?.toLowerCase() === "ad") {
      article = "an Ad";
      title =
        normalizedEventType === "qualifiedview"
          ? "Qualified View - Ad Triggers"
          : "Milestone - Ad Triggers";
    } else if (mediaType?.toLowerCase() === "content") {
      article = "a Content";
      title =
        normalizedEventType === "qualifiedview"
          ? "Qualified View - Content Triggers"
          : "Milestone - Content Triggers";
    } else {
      article = "";
    }
  } else if (mediaType?.toLowerCase() === "ad") {
    article = "an Ad";
  } else if (mediaType?.toLowerCase() === "content") {
    article = "a Content";
  } else {
    article = "";
  }

  const subtitle = article
    ? template.subtitle.replace("[event-media-type]", article)
    : template.subtitle.replace("[event-media-type]", "a");

  return {
    title,
    subtitle,
    settingSourceMsg: template.settingSourceMsg,
    overrideMessage: template.overrideMessage,
  };
};

export const datapointSyncAvailable = (allDataPoints) => {
  const mergedArray = [
    ...(allDataPoints?.event ?? []),
    ...(allDataPoints?.fluxdata ?? []),
    ...(allDataPoints?.metadata?.allMetadata ?? []),
    ...(allDataPoints?.metadata?.applicationMetadata ?? []),
    ...(allDataPoints?.metadata?.cdnMetadata ?? []),
    ...(allDataPoints?.alias?.event ?? []),
    ...(allDataPoints?.alias?.metaData?.applicationMetadata ?? []),
    ...(allDataPoints?.alias?.metaData?.cdnMetadata ?? []),
  ];
  return getUnselectedButIncludedDatapointsByCollector(mergedArray);
};

export const getUnselectedButIncludedDatapointsByCollector = (
  mergedArray = [],
) => {
  const selectedTrueMap = new Map();

  mergedArray.forEach((item) => {
    (item.includes_list ?? []).forEach((inc) => {
      if (inc?.selected && inc?.labelForSync && inc?.dataPointId) {
        const key = `${inc?.labelForSync}__${inc?.dataPointId}`;

        if (!selectedTrueMap.has(key)) {
          selectedTrueMap.set(key, new Set());
        }
        selectedTrueMap.get(key).add(inc?.configName);
      }
    });
  });

  const result = {};

  mergedArray.forEach((item) => {
    (item.includes_list ?? []).forEach((inc) => {
      if (inc?.selected || !inc?.labelForSync || !inc?.dataPointId) return;

      const key = `${inc?.labelForSync}__${inc?.dataPointId}`;
      const selectedInOther = selectedTrueMap.get(key);

      if (!selectedInOther || selectedInOther.has(inc?.configName)) return;

      if (!result[inc?.configName]) {
        result[inc?.configName] = {
          collectorName: inc?.configName,
          datapoints: [],
        };
      }

      if (!result[inc?.configName].datapoints.includes(inc?.labelForSync)) {
        result[inc?.configName].datapoints.push(inc?.labelForSync);
      }
    });
  });

  Object.values(result).forEach((collector) => {
    collector?.datapoints?.sort((a, b) => a?.localeCompare(b));
  });

  return Object.values(result);
};

export const syncSelectedInNestedDataPoints = (
  allDataPoints = [],
  roleName,
) => {
  return allDataPoints?.map((item) => {
    if (item?.required === true) {
      return item;
    }

    const includesList = item?.includesList ?? [];

    if (!includesList.length) {
      return item;
    }

    const hasSelectedTrue = includesList.some((inc) => inc?.selected === true);

    const hasSelectedFalse = includesList.some(
      (inc) => inc?.selected === false,
    );

    let updatedIncludesList = includesList;
    const isVisible = !item?.omitFromUi;
    if (
      hasSelectedTrue &&
      hasSelectedFalse &&
      (roleName === SUPER_ADMIN_ROLE ||
        isVisible ||
        process.env.REACT_APP_NEW_DATAPOINT_TABLE_V2 === "false")
    ) {
      updatedIncludesList = includesList.map((inc) => ({
        ...inc,
        selected: true,
      }));
    }

    return {
      ...item,
      includesList: updatedIncludesList,
    };
  });
};

export const groupByLabelDp = (data = []) => {
  const getMediaType = (item) =>
    (
      item?.labelDp?.mediaType ||
      item?.type?.value ||
      item?.mediaType ||
      ""
    ).toLowerCase();

  const byLabel = new Map();
  data.forEach((item) => {
    const label = item?.labelDp?.value;
    if (!byLabel.has(label)) byLabel.set(label, []);
    byLabel.get(label).push(item);
  });

  const replaceAt = new Map();
  const dropped = new Set();

  byLabel.forEach((itemsByLabel) => {
    const byMediaType = new Map();
    itemsByLabel.forEach((item) => {
      const mt = getMediaType(item);
      if (!byMediaType.has(mt)) byMediaType.set(mt, []);
      byMediaType.get(mt).push(item);
    });

    const hasAd = byMediaType.has("ad");
    const hasContent = byMediaType.has("content");

    if (hasAd && hasContent) {
      const parentItem = itemsByLabel[0];
      const merged =
        parentItem?.children?.length > 0
          ? parentItem
          : {
              ...parentItem,
              type: { value: "Event" },
              children: itemsByLabel,
              isParentGroup: true,
            };
      replaceAt.set(parentItem, [merged]);
      itemsByLabel.slice(1).forEach((i) => dropped.add(i));
      return;
    }

    const uniqueDataPointIds = new Set(
      itemsByLabel.map((item) => item?.datapointId),
    );
    if (uniqueDataPointIds.size > 1) return;

    byMediaType.forEach((items, mediaType) => {
      const isAdOrContent = mediaType === "ad" || mediaType === "content";
      if (isAdOrContent && !(items[0]?.children?.length > 0)) {
        replaceAt.set(items[0], [
          { ...items[0], type: { value: "Event" }, children: items },
        ]);
      }
      items.slice(1).forEach((i) => dropped.add(i));
    });
  });

  return data.flatMap((item) => {
    if (dropped.has(item)) return [];
    return replaceAt.get(item) ?? [item];
  });
};

export const getDatapipeTableV2Titles = () => {
  const result = [];

  result.push({
    key: "labelDp",
    label: "Name",
    sortable: true,
    sortKey: "labelDp",
    width: "30%",
  });

  result.push({
    key: "type",
    label: "Type",
    sortable: true,
    sortKey: "type",
    width: "10%",
  });
  result.push({
    key: "dictionary",
    label: "dictionary",
    sortable: true,
    sortKey: "dictionary",
    width: "20%",
  });

  result.push({
    key: "groupCategory",
    label: "Metadata category",
    sortable: true,
    sortKey: "groupCategory",
    width: "25%",
  });

  result.push({
    key: "required",
    label: "required",
    sortable: true,
    sortKey: "required",
    width: "10%",
  });
  return result;
};

export const getDatapipeTableHeadConfig = () => {
  return [
    {
      key: "icon",
      type: "icon",
      width: 48,
      minWidth: 48,
      maxWidth: 48,
      label: null,
    },
    {
      key: "checkbox",
      type: "checkbox",
      width: 56,
      minWidth: 56,
      label: null,
    },
    {
      key: "labelDp",
      type: "standard",
      label: "NAME",
      sortable: true,
      sortKey: "labelDp",
      flex: 1,
    },
    {
      key: "type",
      type: "standard",
      label: "TYPE",
      sortable: true,
      sortKey: "type",
      width: 250,
      minWidth: 250,
    },
  ];
};

export const groupByNestedProperty = (array, filterUniqueList = {}) => {
  const rows = array ?? [];

  const result = {
    Event: [],
    Filtered_Event: ["Filtered Event"],
    Metadata: [],
  };

  const typeOf = (item) => String(item?.type?.value ?? "").toLowerCase();

  const isFilteredEvent = (item) =>
    ["ad", "content"].includes(
      String(item?.labelDp?.mediaType ?? "").toLowerCase(),
    );

  const hasFilteredEvent = rows.some(
    (item) => isFilteredEvent(item) || item?.children?.some(isFilteredEvent),
  );
  const hasEvent = rows.some((item) => typeOf(item) === "event");
  const hasMetadata = rows.some((item) => typeOf(item).includes("metadata"));

  const inFilterList = (id) =>
    filterUniqueList?.type?.some((item) => item?.id === id);

  const metadataInFilterList =
    inFilterList("Metadata_type") ||
    filterUniqueList?.groupCategory?.length > 0;

  const hasFluxdataInRows = rows.some(
    (item) => item?.type?.value === "Fluxdata",
  );

  const hasFluxdataInFilterList = filterUniqueList?.type?.some(
    (item) =>
      item?.name === "Fluxdata" ||
      item?.id === "Fluxdata_type" ||
      item?.type?.value === "Fluxdata",
  );

  if (hasFluxdataInRows || hasFluxdataInFilterList) {
    result.Fluxdata = ["fluxdata"];
  }

  const metadataTypeItem = filterUniqueList?.type?.find(
    (item) => item?.name === "Metadata",
  );

  if (metadataTypeItem?.children?.length > 0) {
    result.Metadata.push(...metadataTypeItem.children);
  } else {
    rows.forEach((item) => {
      if (typeOf(item).includes("metadata")) {
        const groupValue = item?.groupCategory?.value;
        if (groupValue && !result.Metadata.includes(groupValue)) {
          result.Metadata.push(groupValue);
        }
      }
    });
  }

  const transformedResult = Object.keys(result).map((name) => {
    const obj = {
      key: "type",
      name: name.replace(/_/g, " "),
      id: `${name}_type`,
      type: "type",
    };

    if (name === "Event" && result?.Event?.length > 0) {
      obj.children = result.Event.map((eventName) => ({
        key: "type",
        name: eventName,
        id: `${eventName}_type`,
        type: "type",
      }));
    }

    if (name === "Metadata") {
      if (filterUniqueList?.groupCategory?.length > 0) {
        const sorted = [...filterUniqueList.groupCategory].sort((a, b) => {
          if (a?.name === "--") return -1;
          if (b?.name === "--") return 1;
          return a?.name.localeCompare(b?.name);
        });

        obj.children = sorted.map((item) => ({
          key: "groupCategory",
          name: item?.name === "--" ? "(Blanks)" : item?.name?.trim(),
          id: item.id,
          type: "groupCategory",
        }));
      } else if (result?.Metadata?.length > 0) {
        const sorted = [...result.Metadata].sort((a, b) => {
          if (a === "--" || a?.name === "--") return -1;
          if (b === "--" || b?.name === "--") return 1;
          const aName = a?.name || a;
          const bName = b?.name || b;
          return aName.localeCompare(bName);
        });

        obj.children = sorted.map((groupName) => {
          const name = groupName?.name || groupName;
          return {
            key: "groupCategory",
            name: name === "--" ? "(Blanks)" : `${name}`,
            id:
              name === "--"
                ? "(Blanks)_groupCategory"
                : `${name}_groupCategory`,
            type: "groupCategory",
          };
        });
      }
    }

    return obj;
  });
  return transformedResult.filter((obj) => {
    if (obj.id === "Event_type") {
      return hasEvent || inFilterList("Event_type");
    }
    if (obj.id === "Filtered_Event_type") {
      return hasFilteredEvent || inFilterList("Filtered_Event_type");
    }
    if (obj.id === "Metadata_type") {
      return hasMetadata || metadataInFilterList;
    }
    return true;
  });
};

const dataPointOverlayTemplate_V2 = {
  heartbeat: {
    title: "Heartbeat",
    subtitle:
      "The Heartbeat event fires at the specified interval of time during playback, or right after video playback is interrupted.",
    overrideMessage:
      "Compatibility Mode: Some application sessions from these collector configurations continue to use collector-level settings.",
  },
  milestone: {
    title: "Milestone Triggers",
    subtitle:
      "Within [event-media-type] session, the Milestone event fires when the user passes the point for each milestone percentage specified.",
    overrideMessage:
      "Compatibility Mode: Some application sessions from these collector configurations continue to use collector-level settings.",
  },
  qualifiedview: {
    title: "Qualified View Triggers",
    subtitle:
      "Within [event-media-type] session, the Qualified View event occurs when playback duration passes the specified qualified view thresholds of time",
    overrideMessage:
      "Compatibility Mode: Some application sessions from these collector configurations continue to use collector-level settings.",
  },
};

export const getDataPopUpTextV2 = (eventType, mediaType) => {
  const normalizedEventType = eventType?.replace(/\s+/g, "").toLowerCase();
  // const template = dataPointOverlayTemplate[normalizedEventType];
  const template = dataPointOverlayTemplate_V2[normalizedEventType];
  if (!template) return null;

  let article;
  let { title } = template;

  if (normalizedEventType !== "heartbeat") {
    if (mediaType?.toLowerCase() === "ad") {
      article = "an ad";
      title = title + " (Ad Media Type)";
      // normalizedEventType === "qualifiedview"
      //   ? title + " (Ad Media Type)"
      //   : "Milestone - Ad Triggers";
    } else if (mediaType?.toLowerCase() === "content") {
      article = "a content";
      title = title + " (Content Media Type)";
      // normalizedEventType === "qualifiedview"
      //   ? "Qualified View - Content Triggers"
      //   : "Milestone - Content Triggers";
    } else {
      article = "";
    }
  } else if (mediaType?.toLowerCase() === "ad") {
    article = "an ad";
  } else if (mediaType?.toLowerCase() === "content") {
    article = "a content";
  } else {
    article = "";
  }

  const subtitle = article
    ? template.subtitle.replace("[event-media-type]", article)
    : template.subtitle.replace("[event-media-type]", "a");

  return {
    title,
    subtitle,
    settingSourceMsg: template.settingSourceMsg,
    overrideMessage: template.overrideMessage,
  };
};

export const buildFilterConfigV2 = (dataPoints, filterUniqueList = {}) => {
  const filterKeys = [
    { key: "type", name: "Type" },
    { key: "groupCategory", name: "Metadata Category" },
    { key: "supported", name: "Selected" },
    { key: "isException", name: "Exceptions" },
  ];

  const isMetadata = (v) => v?.toString().trim().toLowerCase() === "metadata";
  const hasMetadataType = filterUniqueList?.type?.length
    ? filterUniqueList.type.some((item) => isMetadata(item?.name ?? item?.id))
    : dataPoints.some((dp) => isMetadata(dp?.type?.value));

  const DPList = filterKeys
    .map(({ key, name }) => {
      let DPValue;

      if (filterUniqueList?.[key]?.length) {
        DPValue = filterUniqueList[key].map((item) => {
          const displayName =
            key === "supported"
              ? item.name === "Yes"
                ? "Selected"
                : item.name === "No"
                ? "Unselected"
                : item.name
              : item.name ?? item.id;

          return {
            id: item.id ?? item.name,
            name: displayName?.trim(),
            type: key,
          };
        });
      } else {
        let values;

        if (key === "isException") {
          const uniqueExceptions = new Set();

          dataPoints.forEach((dp) => {
            if (dp?.isException === true) {
              uniqueExceptions.add("Exception");
            } else if (dp?.isException === false) {
              uniqueExceptions.add("No Exception");
            }
          });

          values = Array.from(uniqueExceptions);
        } else {
          values = [
            ...new Set(
              dataPoints.map((dp) => {
                const raw = dp?.[key]?.value ?? "--";
                return raw && raw.trim() !== "" ? raw : "(Blanks)";
              }),
            ),
          ];
        }

        DPValue = values.map((val) => ({
          id:
            key === "isException"
              ? val === "Exception"
                ? "Exception_isException"
                : "No Exception_isException"
              : val?.trim() === "--"
              ? "(Blanks)" + `_${key}`
              : `${val}_${key}`,
          name:
            key === "supported"
              ? val === "Yes"
                ? "Selected"
                : val === "No"
                ? "Unselected"
                : val
              : val === "--"
              ? "(Blanks)"
              : val?.trim(),
          type: key,
        }));
      }

      DPValue.sort((a, b) => {
        if (key === "isException") {
          if (a.name === "Exception") return -1;
          if (b.name === "Exception") return 1;
          return 0;
        }

        return a.name.localeCompare(b.name);
      });

      if (["Selected", "Exceptions"].includes(name)) {
        DPValue = DPValue?.filter((item) => item?.name !== "(Blanks)");
      }

      if (name === "Type") {
        DPValue = DPValue?.filter((item) => item?.name !== "Filtered Event");
      }

      if (key === "groupCategory" && !hasMetadataType) {
        DPValue = DPValue.filter((item) => item?.name !== "(Blanks)");
      }

      if (!DPValue.length) return null;

      return {
        name,
        DPValue,
        quickFilter: true,
      };
    })
    ?.filter(Boolean);

  return { DPList };
};

export const getUniqueDataPointRowsTableV2 = (inputArray, typeKey) => {
  const seen = new Set();
  const skipBlanks = [
    "selected",
    "type",
    "dictionary",
    "required",
    "isException",
  ].includes(typeKey);

  if (typeKey === "isException") {
    const hasException = inputArray?.some((item) => item?.isException === true);
    const hasNoException = inputArray?.some(
      (item) => item?.isException === false,
    );

    const result = [];
    if (hasException) {
      result.push({
        key: typeKey,
        name: "Exception",
        id: "Exception_isException",
        type: typeKey,
      });
    }
    if (hasNoException) {
      result.push({
        key: typeKey,
        name: "No Exception",
        id: "No Exception_isException",
        type: typeKey,
      });
    }
    return result;
  }

  return inputArray
    ?.slice()
    ?.sort((a, b) =>
      (a?.[typeKey]?.value || "")
        .toLowerCase()
        .localeCompare((b?.[typeKey]?.value || "").toLowerCase()),
    )
    .filter((item) => {
      const val = item?.[typeKey]?.value || "--";
      if (skipBlanks && val === "--") return false;
      if (seen.has(val)) return false;
      seen.add(val);
      return true;
    })
    .map((item) => {
      const rawValue = item?.[typeKey]?.value || "--";
      const displayValue = rawValue === "--" ? "(Blanks)" : rawValue;
      return {
        key: typeKey,
        name: displayValue,
        id: `${displayValue}_${typeKey}`,
        type: typeKey,
      };
    });
};

export const getDataPointRowsTableV2 = (
  dataPoints,
  selectedFilterPopOver,
  sortConfig,
  query,
  datapointMappingDetails,
  overrideValue,
) => {
  if (!dataPoints?.length) return [];
  const oldDataPoints = dataPoints?.map((dp) =>
    mapDataPointTableV2(dp, overrideValue),
  );
  const mappedRows = dataPoints?.map((dp) =>
    mapDataPointTableV2(dp, overrideValue),
  );
  let rows = [...mappedRows];

  if (selectedFilterPopOver?.length) {
    const filterGroups = selectedFilterPopOver.reduce((acc, f) => {
      (acc[f.key] ||= []).push(
        f?.type === "groupCategory"
          ? f?.name?.split("Metadata")?.[0]?.trim()
          : f?.name,
      );
      return acc;
    }, {});

    const COMBINED_KEYS = ["type", "groupCategory"];

    const isBlank = (v) =>
      v == null || String(v).trim() === "" || String(v).trim() === "--";

    const isMetadataRow = (dp) =>
      String(dp?.type?.value ?? "")
        .toLowerCase()
        .includes("metadata");

    const matchesValue = (dp, key, val) => {
      const dpValue = dp?.[key]?.value ?? "--";

      if (val === "Yes") return dpValue === "Yes";
      if (val === "No") return dpValue === "No";

      if (key === "source") {
        if (val === "Application") return dpValue === "Application";
        if (val === "CDN") return dpValue === "CDN";
      }

      if (key === "type" && val === "Filtered Event") {
        return (
          dp?.labelDp?.mediaType === "ad" ||
          dp?.labelDp?.mediaType === "content"
        );
      }

      if (key === "isException" && val === "Exception") {
        return dp?.isException === true;
      }
      if (key === "isException" && val === "No Exception") {
        return dp?.isException === false;
      }

      if (key === "supported" && val === "Selected") {
        return dp?.supported?.value === "Yes";
      }
      if (key === "supported" && val === "Unselected") {
        return dp?.supported?.value === "No";
      }

      if (val === "(Blanks)") {
        if (key === "groupCategory") {
          return isMetadataRow(dp) && isBlank(dp?.groupCategory?.value);
        }
        return isBlank(dpValue);
      }

      if (key === "groupCategory") {
        return String(dpValue).toLowerCase() === String(val).toLowerCase();
      }

      return dpValue === val;
    };

    const keys = Object.keys(filterGroups);
    const combinedKeys = keys.filter((k) => COMBINED_KEYS.includes(k));
    const otherKeys = keys.filter((k) => !COMBINED_KEYS.includes(k));

    rows = rows.filter((dp) => {
      const othersOk = otherKeys.every((key) =>
        filterGroups[key].some((val) => matchesValue(dp, key, val)),
      );
      if (!othersOk) return false;

      if (!combinedKeys.length) return true;
      return combinedKeys.some((key) =>
        filterGroups[key].some((val) => matchesValue(dp, key, val)),
      );
    });
  }

  if (query?.trim()) {
    const q = query.toLowerCase();
    rows = rows.filter(
      (dp) =>
        dp.labelDp?.value?.toLowerCase().includes(q) ||
        dp.group?.value?.toLowerCase().includes(q) ||
        dp.labelDp?.tooltipName?.toLowerCase().includes(q),
    );
  }

  if (sortConfig?.sortBy) {
    const { sortBy, sortOrder } = sortConfig;
    const isMissing = (v) =>
      v == null || String(v).trim() === "" || String(v).trim() === "--";

    const getVal = (row) => {
      const cellValue = row?.[sortBy]?.value;
      let raw = cellValue;

      if (
        sortBy === "type" &&
        String(cellValue).toLowerCase().includes("metadata")
      ) {
        const group = row?.groupCategory?.value;
        raw = isMissing(group) ? "Metadata" : group;
      }

      return isMissing(raw) ? "--" : raw.toString().trim().toLowerCase();
    };

    rows.sort((a, b) => {
      const valA = getVal(a);
      const valB = getVal(b);

      if (valA === "--" && valB === "--") return 0;
      if (valA === "--") return 1;
      if (valB === "--") return -1;

      return sortOrder ? valA.localeCompare(valB) : valB.localeCompare(valA);
    });
  }

  return rows;
};

// mapping helper
const mapDataPointTableV2 = (dataPoint, overrideValue) => {
  const required = !!dataPoint?.required;
  const hasSelectedInIncludes =
    Array.isArray(dataPoint?.includesList) &&
    dataPoint.includesList.some((inc) => inc?.selected);

  const supportedValue =
    hasSelectedInIncludes || dataPoint?.required === true ? "Yes" : "No";
  const restrictedDictionaries = ["Video Player v.2", "CDN v.3"];
  const isEditableLabel =
    (dataPoint?.label === "Heartbeat" ||
      dataPoint?.label === "Milestone" ||
      dataPoint?.label === "Qualified View") &&
    !restrictedDictionaries?.some((name) =>
      dataPoint?.dictionaryName?.includes(name),
    );

  let editDisplayValue = "";
  if (dataPoint?.label === "Heartbeat") {
    editDisplayValue = `${
      overrideValue?.playHeadFrequency ? overrideValue?.playHeadFrequency : 60
    } seconds`;
  } else if (dataPoint?.label === "Milestone") {
    if (dataPoint?.mediaType === "ad") {
      const msAdLength =
        overrideValue?.msAd?.split(",")?.filter(Boolean).length || 0;
      editDisplayValue =
        msAdLength > 0
          ? `${msAdLength} ${msAdLength > 1 ? "triggers" : "trigger"}`
          : "3 triggers";
    } else if (dataPoint?.mediaType === "content") {
      const msContentLength =
        overrideValue?.msContent?.split(",")?.filter(Boolean).length || 0;
      editDisplayValue =
        msContentLength > 0
          ? `${msContentLength} ${msContentLength > 1 ? "triggers" : "trigger"}`
          : "7 triggers";
    }
  } else if (dataPoint?.label === "Qualified View") {
    if (dataPoint?.mediaType === "ad") {
      const qvAdLength =
        overrideValue?.qvAd?.split(",")?.filter(Boolean).length || 0;
      editDisplayValue =
        qvAdLength > 0
          ? `${qvAdLength} ${qvAdLength > 1 ? "triggers" : "trigger"}`
          : "1 trigger";
    } else if (dataPoint?.mediaType === "content") {
      const qvContentLength =
        overrideValue?.qvContent?.split(",")?.filter(Boolean).length || 0;
      editDisplayValue =
        qvContentLength > 0
          ? `${qvContentLength} ${qvContentLength > 1 ? "triggers" : "trigger"}`
          : "2 triggers";
    }
  }

  return {
    labelDp: {
      value: dataPoint?.label ?? "--",
      supported: supportedValue,
      isEditableLabel,
      editDisabled: supportedValue === "No",
      ...(isEditableLabel === true && { editDisplayValue }),
      dictionary: dataPoint?.dictionary ?? "--",
      mediaType: dataPoint?.mediaType,
      tooltipName:
        dataPoint?.dictionary?.toLowerCase() === "custom" &&
        dataPoint?.type === "Event"
          ? `"custom_ ${dataPoint?.name}"`
          : `"${dataPoint?.name}"`,
      definition: dataPoint?.definition,
      omitFromUi: dataPoint?.omitFromUi,
      deprecated: dataPoint?.deprecated,
    },
    type: { value: dataPoint?.type ?? "--" },
    dictionary: { value: dataPoint?.dictionary ?? "--" },
    method: { value: "--" },
    groupCategory: { value: dataPoint?.group ?? "--" },
    required: { value: required ? "Yes" : "No" },
    supported: { value: supportedValue },
    source: {
      value: dataPoint?.collectorType,
    },
    exception_list: Array.isArray(dataPoint?.exceptionList)
      ? dataPoint.exceptionList.filter(
          (item) => item?.collectorType === dataPoint?.collectorType,
        )
      : [],
    datapointId: dataPoint?.dataPointId,
    disabled: dataPoint?.disabled || false,
    originalSupported: { value: supportedValue },
    deprecated: dataPoint?.deprecated,
    isException:
      Array.isArray(dataPoint?.exceptionList) &&
      dataPoint?.exceptionList?.some(
        (item) => item?.collectorType === dataPoint?.collectorType,
      ),
  };
};

export const getDeprecatedDeselected = (initialData = [], updatedData = []) => {
  const keyOf = (item) => `${item.name}|${item.dataPointId}`;

  const updatedByKey = new Map(updatedData.map((item) => [keyOf(item), item]));

  return initialData
    .filter((item) => item.selected === true)
    .map((initialItem) => {
      const updatedItem = updatedByKey.get(keyOf(initialItem));

      if (!updatedItem) {
        return initialItem.deprecated === true ? initialItem : null;
      }

      return updatedItem.selected === false &&
        updatedItem.deprecated === true &&
        updatedItem.required === false
        ? updatedItem
        : null;
    })
    .filter(Boolean);
};

export const getSelectedItemsExcludingDeprecated = (collectorConfigs) => {
  return collectorConfigs?.map((collectorConfig) => {
    const selectedCollectorConfig = {
      configId: collectorConfig.configId,
    };
    const general = {};
    if (collectorConfig.general) {
      if (Array.isArray(collectorConfig.general.eventList)) {
        general.eventsList = collectorConfig.general.eventList
          .filter((item) => item && Array.isArray(item.datapointsList))
          .flatMap((item) =>
            item.datapointsList
              .filter(
                (dp) => !(dp?.deprecated === true && dp?.required === false),
              )
              .map((dp) => ({
                id: dp?.id || dp.dataPointId,
                selectedMediaType: dp?.mediaTypeName,
              })),
          );
      }

      if (Array.isArray(collectorConfig.general.fluxDataList)) {
        general.fluxDataList = collectorConfig.general.fluxDataList
          .filter(
            (item) =>
              item?.name &&
              !(item.deprecated === true && item.required === false),
          )
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.general.metaDataList)) {
        general.metaDataList = collectorConfig.general.metaDataList
          .filter(
            (item) =>
              item?.name &&
              !(item.deprecated === true && item.required === false),
          )
          .map((item) => ({ id: item.dataPointId }));
      }
    }
    selectedCollectorConfig.general = general;

    if (collectorConfig.mediaPlayer) {
      const mediaPlayer = {};

      if (Array.isArray(collectorConfig.mediaPlayer.eventList)) {
        mediaPlayer.eventsList = collectorConfig.mediaPlayer.eventList
          .filter((item) => item && Array.isArray(item.datapointsList))
          .flatMap((item) =>
            item.datapointsList
              .filter(
                (dp) => !(dp?.deprecated === true && dp?.required === false),
              )
              .map((dp) => ({
                id: dp?.id || dp.dataPointId,
                selectedMediaType: dp?.mediaTypeName,
              })),
          );
      }

      if (Array.isArray(collectorConfig.mediaPlayer.fluxDataList)) {
        mediaPlayer.fluxDataList = collectorConfig.mediaPlayer.fluxDataList
          .filter(
            (item) =>
              item?.name &&
              !(item.deprecated === true && item.required === false),
          )
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.mediaPlayer.metaDataList)) {
        mediaPlayer.metaDataList = collectorConfig.mediaPlayer.metaDataList
          .filter(
            (item) =>
              item?.name &&
              !(item.deprecated === true && item.required === false),
          )
          .map((item) => ({ id: item.dataPointId }));
      }

      if (
        (mediaPlayer.eventsList && mediaPlayer.eventsList.length > 0) ||
        (mediaPlayer.fluxDataList && mediaPlayer.fluxDataList.length > 0) ||
        (mediaPlayer.metaDataList && mediaPlayer.metaDataList.length > 0)
      ) {
        selectedCollectorConfig.mediaPlayer = mediaPlayer;
      }
    }

    if (Array.isArray(collectorConfig.custom)) {
      const custom = collectorConfig.custom
        .filter(
          (item) => !(item?.deprecated === true && item?.required === false),
        )
        .map((item) => ({ id: item.dataPointId }));
      if (custom.length > 0) {
        selectedCollectorConfig.custom = custom;
      }
    }

    if (Array.isArray(collectorConfig.vendor)) {
      const vendor = collectorConfig.vendor
        .filter(
          (item) => !(item?.deprecated === true && item?.required === false),
        )
        .map((item) => ({ id: item.dataPointId }));
      if (vendor.length > 0) {
        selectedCollectorConfig.vendor = vendor;
      }
    }

    if (collectorConfig.alias) {
      const customDetectedDataPoint = {};

      if (Array.isArray(collectorConfig.alias.events)) {
        customDetectedDataPoint.event = collectorConfig.alias.events
          .filter(
            (item) =>
              item?.name &&
              !(item.deprecated === true && item.required === false),
          )
          .map((item) => ({ id: item.dataPointId }));
      }

      if (Array.isArray(collectorConfig.alias.metadata)) {
        customDetectedDataPoint.metadata = collectorConfig.alias.metadata
          .filter(
            (item) =>
              item?.name &&
              !(item.deprecated === true && item.required === false),
          )
          .map((item) => ({ id: item.dataPointId }));
      }

      if (
        (customDetectedDataPoint.event &&
          customDetectedDataPoint.event.length > 0) ||
        (customDetectedDataPoint.metadata &&
          customDetectedDataPoint.metadata.length > 0)
      ) {
        selectedCollectorConfig.alias = customDetectedDataPoint;
      }
    }
    return selectedCollectorConfig;
  });
};
